import {
  Link as ChakraLink,
  Text,
  Input,
  Box,
  Badge,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Select,
  Heading,
  Avatar,
  Grid,
  GridItem,
  Center,
  Divider,
  Spinner,
  Progress,
  Tooltip,
  Alert,
  AlertIcon,
  HStack,
  useToast,
  Flex,
  Spacer,
  MenuButton,
  MenuList,
  MenuItem,
  Menu,
  VStack,
  MenuGroup,
  IconButton,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  InputRightAddon,
  FormControl,
  FormLabel,
  Checkbox,
  Radio
} from '@chakra-ui/react'
import Head from 'next/head'
import { useSession, signIn, signOut, getSession } from "next-auth/react"
import { useProtectedSession } from '../hooks/useProtectedSession'
import { useRouter } from 'next/router'

import axios from 'axios';
import JSZip from "jszip";
import { withInvoiceQueueConsumerTarget } from "../utils/url";
import { saveAs } from "file-saver";
import {
  expandUploadFiles,
  isAllowedInvoiceUploadFile,
  ZIP_UPLOAD_ACCEPT,
} from "../utils/expandUploadFiles";

import exportFromJSON from 'export-from-json'

import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";

import Link from 'next/link'
import { IoChevronDown, IoHelpCircle, IoHappy,IoShapes, IoEarth, IoMedkit, IoCar, IoBicycle,IoAddCircleOutline, IoSchool, IoShirt, IoPint, IoPizza, IoAtCircle, IoAirplane, IoHome, IoSubway, IoColorPalette, IoTv, IoFitness, IoPaw, IoMusicalNotes, IoSettings, IoExit, IoChevronForward, IoBriefcase, IoOpen, IoInformationCircle, IoCheckmarkDoneCircleSharp, IoCash,IoCheckmarkCircle, IoDownload ,IoCloudUpload,IoSave,IoDocumentAttachOutline , IoPersonAdd, IoAddCircle, IoShare,IoTrash, IoPersonCircleSharp, IoTimer, IoLockClosed, IoCloseCircle, IoCheckbox, IoCheckmarkDoneCircle, IoReceipt, IoGlobe, IoRemove, IoRemoveCircle, IoChevronForwardOutline, IoChevronBack, IoColorWand, IoAlertCircleOutline, IoAlertCircle, IoFilter, IoSearch, IoClose, IoRefreshCircle, IoSwapHorizontal } from 'react-icons/io5';


import { Container } from '../components/Container'
import SubscriptionManager from '../components/SubscriptionManager'


import MenuElement from "../components/MenuElement"
import TutorialModal from '../components/TutorialModal';
import InvoiceDetailDrawer from '../components/InvoiceDetailDrawer';

import DeleteModal from '../components/DeleteModal';
import QueueProgressOverlay from '../components/QueueProgressOverlay';

import ReactGA from 'react-ga4'; ReactGA.initialize('G-0GRPP85B5D');

import React, { useState, useRef, Component } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import internal from 'stream';
import { open } from 'fs/promises';
import { create } from 'lodash';
import { stat } from 'fs';
import { throws } from 'assert';

import Board from 'react-trello'


import InfiniteScroll from 'react-infinite-scroller';

import { Card, ProgressBar } from "@tremor/react";

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'



// (PDF libs were used experimentally before; keep this page free of unused PDF imports)
import { userAgent } from 'next/server';


import * as Scroll from 'react-scroll';
import {Element, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

import AllIcons from '../constants/AllIcons';

const mainContainer= {maxWidth: "1200px", display: "block", margin: "auto"}


let CustomCard = (data) =>{

  let item = data;

  return (
    <Box padding="3" backgroundColor={"white"} borderWidth='1px' borderRadius='lg' mb="2" style={{transition: "all 0.2s"}}
    _hover={{
      cursor: "pointer",
      backgroundColor: "#f4f4f4"
    }}
    >
      <Heading  as='h4' size='sm'>
        {item.shop}
      </Heading>
      <Box display='flex' alignItems='baseline'>
        <Box
          color='gray.500'
          fontWeight='semibold'
          letterSpacing='wide'
          textTransform='uppercase'
          ml='0'
        >
          {item.date}
        </Box>
      </Box>
      <Heading  as='h4' size='sm'>
        {item.shop}
      </Heading>
    </Box>
  )
}

  class NewCardForm extends Component {
    //handleAdd = () => this.props.onAdd({title: this.titleRef.value, description: this.descRef.value})
    //setTitleRef = (ref) => this.titleRef = ref
    //setDescRef = (ref) => this.descRef = ref
    render() {
      //const {onCancel} = this.props
      return (
        <Box>
          <Input></Input>
        </Box>
      )
    }
  }

const menuWrapper = {
  maxWidth: "1240px",
  position: "relative" as "relative",
  display: "block",
  margin: "auto"
}

const Index = ({sessionServerSide, checkSubscription, tabIndexMenu}) => {
  const [rekeningData, setRekeningData] = useState([]);
  const [viewStyle, setViewStyle] = useState("Kanban");
  const toast = useToast()

  const {t, i18n} = useTranslation('common')


  const [rekeningDataOriginal, setRekeningDataOriginal] = useState([]);
  const [travelExpenseData, setTravelExpenseData] = useState([]);

  const [budgetSpendingData, setBudgetSpendingData] = useState({spending: {}, totalSpending: 0.0})

  const [selectedInvoicesIds, setSelectedInvoicesIds] = useState([]);
  const [selectedInvoiceMonths, setSelectedInvoiceMonths] = useState([])


  const [invoiceTypesData, setInoviceTypesData] = useState([]);


  const [changedInvoices, setChangedInvoices] = useState([]);

  const [moreInvoicesAvailable, setMoreInvoicesAvailable] = useState(true);


  const [editInvoiceTypeWorkflow, setEditInvoiceTypeWorkflow] = useState({steps: [], title: ""});

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingRefund, setIsLoadingRefund] = useState(false);

  const [isLoadingRequestRefund, setIsLoadingRequestRefund] = useState(false);


  const [editInvoiceReadonly, setEditInvoiceReadonly] = useState(false);
  const [editInvoiceReadonlyReason, setEditInvoiceReadonlyReason] = useState("This invoice is locked");
  const [editInvoiceModified, setEditInvoiceModified] = useState(false);

  const [bulkUploadData, setBulkUploadData] = useState([]);
  const [bulkUploadSettings, setBulkUploadSettings] = useState({category: "", invoiceType: ""});
  const [bulkUploadCounterFinished, setBulkUploadCounterFinished] = useState(0);
  const [bulkUploadCounterTotal, setBulkUploadCounterTotal] = useState(0);
  
  // Async upload and queue tracking
  const [uploadedFileCount, setUploadedFileCount] = useState(0);
  const [totalFilesToUpload, setTotalFilesToUpload] = useState(0);

  // File input ref for bulk upload
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);
  const [queueEntryIds, setQueueEntryIds] = useState([]);
  const [isQueueOverlayVisible, setIsQueueOverlayVisible] = useState(false);
  const [invoiceQueueCounts, setInvoiceQueueCounts] = useState({ active: 0, total: 0 });

  const [categoriesData, setCategoriesData] = useState([]);



  const [userData, setUserData] = useState([]);

  const [tabIndex, setTabIndex] = useState(parseInt(tabIndexMenu))


  //NEW
  const [searchValues, setSearchValues] = useState([{key: "searchText", value: ""},{key: "searchUser", value: ""}]);

  // New filter state management
  const [filterView, setFilterView] = useState("alle"); // "alle" or "meine"
  const [activeFilters, setActiveFilters] = useState([]);
  const [dateFilter, setDateFilter] = useState(null);
  const [receiptFilter, setReceiptFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [userFilter, setUserFilter] = useState(null);
  const [invoiceTypeFilter, setInvoiceTypeFilter] = useState(null);
  const [invoiceKindFilter, setInvoiceKindFilter] = useState(null);
  const [transactionTypeFilter, setTransactionTypeFilter] = useState(null);
  const [transactionLinkedFilter, setTransactionLinkedFilter] = useState(null);
  const [searchText, setSearchText] = useState("");

  // Advanced filter modal state
  const { isOpen: isAdvancedFilterOpen, onOpen: onAdvancedFilterOpen, onClose: onAdvancedFilterClose } = useDisclosure()
  const [advancedFilters, setAdvancedFilters] = useState({
    dateRange: null,
    amountFrom: "",
    amountTo: "",
    transactionType: null,
    users: [],
    creditors: [],
    categories: [],
    invoiceTypes: [],
    invoiceStatuses: [],
    invoiceKinds: []
  });
  const [creditorsData, setCreditorsData] = useState([]);

  const [totalVisibleValue, setTotalVisibleValue] = useState("0");



  const [selectedInvoice, setSelectedInvoice] = useState(0)
  // Source-of-truth selection to avoid index drift when `rekeningData` changes (e.g. parallel uploads/inserts).
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(null)
  const [selectedInvoiceNextStep, setSelectedInvoiceNextStep] = useState(undefined);

  const [loginRequired, setLoginRequired] = useState(false);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [viewImage, setViewImage] = React.useState();

  const [createInvoice, setCreateInvoice] = useState(false);
  const [createInvoiceType, setCreateInvoiceType] = useState("");



  const api_url = process.env.NEXT_PUBLIC_API_URL

  const { isOpen: isRefundOpen, onOpen: onRefundOpen, onClose: onRefundClose } = useDisclosure()
  const { isOpen: isRequestRefundOpen, onOpen: onRequestRefundOpen, onClose: onRequestRefundClose } = useDisclosure()

  const { isOpen: isDownloadOpen, onOpen: onDownloadOpen, onClose: onDownloadClose } = useDisclosure()

  const { isOpen: isUpgradeOpen, onOpen: onUpgradeOpen, onClose: onUpgradeClose } = useDisclosure()

  const { isOpen: invoiceIsOpen, onOpen: invoiceOnOpen, onClose: invoiceOnClose } = useDisclosure()

  const { isOpen: isOpenBulkUploadPrep, onOpen: onOpenBulkUploadPrep, onClose: onCloseBulkUploadPrep } = useDisclosure()

  const { isOpen: isOpenBulkUpload, onOpen: onOpenBulkUpload, onClose: onCloseBulkUpload } = useDisclosure()

  //  Delete Confirm Modal
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);


  //Upload Duplicate
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
  const [duplicateCurrentFile, setDuplicateCurrentFile] = useState(null);
  const [duplicateUserDecision, setDuplicateUserDecision] = useState(null);

  const handleDuplicateOverwrite = () => {
      duplicateUserDecision('overwrite');
  };

  const handleDuplicateSkip = () => {
      duplicateUserDecision('skip');
  };

  const emptyTravelExpense = {
    kind:"travel-expense",
    uuid:"",
    shop:"",
    description:"",
    invoiceStatus: "",
    category:"",
    tax: "0",
    mwst: "0",
    total: "",
    totalNet: "",
    currency: "",
    taxPositions:[],
    travelExpense:{
      locationFrom:"",
      locationTo:"",
      transportation:"train",
      transportationDistance:"",
      breakfasts:0,
      lunches:0,
      dinners:0,
      startDate:new Date().toUTCString(),
      endDate:new Date().toUTCString(),
      country: "DE",
      allowanceSmall: "14",
      allowanceBig: "28",
      compensation: "0",
    },
    author: "",
    authorData:[{name:""}],
    childInvoices:[],
};

  const [travelExpense,setTravelExpense] = useState(emptyTravelExpense);
  const [newTravelExpense,setNewTravelExpense] = useState(true);


  const [monthlyCost, setMonthlyCost] = useState({});
  const [totalCost, setTotalCost] = useState(0);
  const [travelExpenseFilter, setTravelExpenseFilter] = useState([]);
  const [bulkInsertData, setBulkInsertData] = useState([]);

  const [travelExpenseLoadHasMore, setTravelExpenseLoadHasMore] = useState(true);


  const { isOpen: isTutorialOpen, onOpen: onTutorialOpen, onClose: onTutorialClose } = useDisclosure()



  //TRAVEL EXPENSE
  const { isOpen: isTravelExpenseOpen, onOpen: onTravelExpenseOpen, onClose: onTravelExpenseClose } = useDisclosure()


  // Use the protected session hook instead of direct useSession
  const { session, status } = useProtectedSession()

  const currency = "€"

  const { query } = useRouter();


  const router = useRouter();
  // Prevent re-opening the same invoice repeatedly when data/state updates while the URL parameter remains.
  const lastOpenedInvoiceIdRef = useRef<string | null>(null);

  const setInvoiceIdInUrl = (invoiceId: string | null) => {
    const nextQuery: any = { ...router.query };
    if (!invoiceId) {
      delete nextQuery.invoiceId;
    } else {
      nextQuery.invoiceId = invoiceId;
    }

    router.replace({ pathname: router.pathname, query: nextQuery }, undefined, { shallow: true });
  }

  const applyReadonlyForInvoice = (invoice: any) => {
    let editInvoiceReadonlyTemp = false;
    let editInvoiceReadonlyReasonTemp = "";

    // User ist owner
    if ((session?.user_data?.["_id"] != invoice?.author && !session?.rights?.includes("view-all-invoices"))) {
      editInvoiceReadonlyTemp = true;
      editInvoiceReadonlyReasonTemp = "This invoice is locked since it is currently in editing by its owner";
    }

    setEditInvoiceReadonlyReason(editInvoiceReadonlyReasonTemp);
    setEditInvoiceReadonly(editInvoiceReadonlyTemp);
  }

  // Keep `selectedInvoice` (index) synced to the selected ID so list mutations won’t change the opened invoice.
  React.useEffect(() => {
    if (!selectedInvoiceId) return;
    const idx = rekeningData.findIndex((inv) => inv?._id === selectedInvoiceId);
    if (idx !== -1 && idx !== selectedInvoice) {
      setSelectedInvoice(idx);
    }
  }, [selectedInvoiceId, rekeningData, selectedInvoice]);

  // Open & reload invoice by ID (used by URL deep-link, list clicks, prev/next)
  const openInvoiceById = async (
    invoiceId: string,
    opts?: { updateUrl?: boolean; openDrawer?: boolean }
  ) => {
    if (!session?.accessToken || !invoiceId) return;

    const updateUrl = opts?.updateUrl !== false;
    const openDrawer = opts?.openDrawer !== false;

    // Avoid double-open when we set `invoiceId` into the URL ourselves (the URL effect would otherwise retrigger).
    lastOpenedInvoiceIdRef.current = invoiceId;

    if (updateUrl) setInvoiceIdInUrl(invoiceId);
    setSelectedInvoiceId(invoiceId);
    setCreateInvoice(false);

    const existingIndex = rekeningData.findIndex((inv) => inv?._id === invoiceId);
    const existingInvoice = existingIndex !== -1 ? rekeningData[existingIndex] : null;

    // If already in list, open immediately with current data (fast) and then refresh.
    if (existingInvoice) {
      applyReadonlyForInvoice(existingInvoice);
      setSelectedInvoice(existingIndex);
      loadBudgetSpending(existingInvoice.category);
      if (openDrawer) invoiceOnOpen();
    }

    try {
      const response = await axios.get(`${api_url}/invoices/${invoiceId}`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });

      if (response.status === 200 && response.data) {
        const invoiceFromServer = response.data;

        setRekeningData((prev) => {
          const idx = prev.findIndex((e) => e?._id == invoiceId);
          if (idx === -1) return [invoiceFromServer, ...prev];
          const next = [...prev];
          next[idx] = invoiceFromServer;
          return next;
        });

        applyReadonlyForInvoice(invoiceFromServer);
        loadBudgetSpending(invoiceFromServer.category);

        // If it wasn't in the list, open after we inserted it at the beginning.
        if (!existingInvoice) {
          setSelectedInvoice(0);
          if (openDrawer) invoiceOnOpen();
        }
      } else {
        userNotification(t('components.index.invoiceNotFound'), t('components.index.invoiceNotFoundDescription'), 'error');
      }
    } catch (error) {
      console.error('Error loading invoice by ID:', error);
      userNotification(t('components.index.invoiceNotFound'), t('components.index.invoiceNotFoundDescription'), 'error');
    }
  };

  const closeInvoiceDrawer = () => {
    setInvoiceIdInUrl(null);
    setSelectedInvoiceId(null);
    lastOpenedInvoiceIdRef.current = null;
    invoiceOnClose();
  }

  // Check for invoiceId URL parameter
  React.useEffect(() => {
    if (!session?.accessToken) return;
    
    const rawInvoiceId = router.query.invoiceId;
    const invoiceIdFromUrl = Array.isArray(rawInvoiceId) ? rawInvoiceId[0] : rawInvoiceId;

    if (invoiceIdFromUrl && lastOpenedInvoiceIdRef.current !== invoiceIdFromUrl) {
      lastOpenedInvoiceIdRef.current = invoiceIdFromUrl;
      // Open from deep-link without re-writing the same URL again.
      openInvoiceById(invoiceIdFromUrl, { updateUrl: false, openDrawer: true });
    }
  }, [router.query.invoiceId, session?.accessToken]);

  React.useEffect(() => {
    if (!session?.accessToken) return;
    
    //loadInvoices();
    loadUser();
    loadCategories();
    loadCreditors();
    if(tabIndex == 1){
      loadTravelExpenses();
    }else{

    }
    loadInvoiceTypes();
    if(checkSubscription == "true"){
      updateSubscription()
    }
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, [query, session?.accessToken])

  React.useEffect(() => {
    setTabIndex(tabIndexMenu)
  },[tabIndexMenu])

  const updateSubscription = async () =>{
    if (!session?.accessToken) return;

    const fetchData = await fetch(`${api_url}/teams/subscription/update`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      }
    })
    const fetchDataJson = await fetchData.json();
    if("statusCode" in fetchDataJson){
    }else{
        //window.location.href = fetchDataJson.url;
    }
}
  const userNotification = async (title, subTitle, status) => {
    toast({
      title: title,
      description: subTitle,
      status: status,
      duration: 5000,
      isClosable: true,
      position: 'bottom-left',
    })
  }

  const loadUser = async () =>{
    if (!session?.accessToken) return;
    
    try{

      const fetchData = axios.get(`${api_url}/users`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){
        setUserData(data.data);
        return data.data;
      }
    }catch (ex){
      return
    }
  }
  const loadCategories = async () =>{
    if (!session?.accessToken) return;

    try{

      const fetchData = axios.get(`${api_url}/categories`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){

        //ADD Web icon to category list for dispalying
        let categoryList = data.data;
        categoryList.map((element, i)=>{
          let displayIcon = AllIcons.find((e)=> e.iconWeb == element.iconWeb);
          categoryList[i]["iconWebElement"] = displayIcon.iconWebElement
        })

        //set data
        setCategoriesData(categoryList);

        return data.data;
      }
    }catch (ex){
      return
    }
  }

  const loadBudgetSpending = async (categoryId) =>{
    if (!session?.accessToken) return;
    if(categoryId == undefined){
      return
    }

    try{
      const fetchDataCategory = axios.get(`${api_url}/invoices/spendingPerCategory/${categoryId}`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const dataCategory = await fetchDataCategory;

      if(dataCategory.status != 403 && dataCategory.status != 500){
        setBudgetSpendingData({...dataCategory.data});
      }
    }catch (ex){
      return
    }
  }

  const calculateMonthlyCost = async(data)=>{
    let existingInvoices = rekeningData;
    let totalCostTemp = 0.0;

    if(data != undefined){
      existingInvoices = data;
    }

    existingInvoices.sort(function(a,b){
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
    setRekeningData([...existingInvoices]);
    let monthlyCostTemp = {};
    existingInvoices.map(function(item, index){
      var invDate = new Date(item.date).toLocaleString();

      const dateNew = new Date(item.date).getMonth();
      const yearNew = new Date(item.date).getFullYear();
      let key = yearNew+"_"+dateNew;
      //const dateArray = invDate.split(".");
      //var dateNew = parseInt(dateArray[1]) -1;

      if(key in monthlyCostTemp == false){
        monthlyCostTemp[key] = 0;
      }

      let singelItemPrice = item.total;
      if(typeof singelItemPrice == "string"){
        singelItemPrice = singelItemPrice.replace(",", ".");
      }
      var currentCost = monthlyCostTemp[key];

      var totalPrice = (parseFloat(singelItemPrice) + parseFloat(currentCost)).toFixed(2);
      monthlyCostTemp[key] = totalPrice;
      totalCostTemp = totalCostTemp + parseFloat(singelItemPrice);
    });

    setTotalCost(parseFloat(totalCostTemp.toFixed(2)))

    setMonthlyCost(monthlyCostTemp);
  }

  const loadInvoices = async (pageNumber = 1) =>{
    // Use the helper function for consistency
    return loadInvoicesWithSearchValues(searchValues, pageNumber);
  }

  const loadSingleInvoices = async (invoiceId) =>{
    if (!session?.accessToken) return;

    try{
      const fetchData = axios.get(`${api_url}/invoices/${invoiceId}`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){
        let rekeningDataTempResponse = data.data;
        //setRekeningData(invoiceDataCombined);
        //calculateMonthlyCost(invoiceDataCombined);
        const indexToReplace = rekeningData.findIndex(e => e._id == invoiceId);
        if (indexToReplace === -1) {
          // If invoice wasn't in list (edge-case), append it.
          setRekeningData([...rekeningData, rekeningDataTempResponse]);
        } else {
          // IMPORTANT: create a new array reference so React re-renders.
          const next = [...rekeningData];
          next[indexToReplace] = rekeningDataTempResponse;
          setRekeningData(next);
        }

        return rekeningDataTempResponse;
      }

    }catch (ex){
      setLoginRequired(false);
      setIsLoading(false);
    }
  }

  const scrollLoadMoreInvoices = async(pageNumber)=>{
    loadInvoicesWithSearchValues(searchValues, pageNumber);
    /*let offset = numberScrolled * 200,
    limit = 200,
    travelExpenseFilterTemp = travelExpenseFilter,
    filterExistsOffset = travelExpenseFilterTemp.findIndex((e)=> e.key == "offset"),
    filterExistsLimit = travelExpenseFilterTemp.findIndex((e)=> e.key == "limit");

    if(filterExistsOffset == -1){
      travelExpenseFilterTemp.push({key: "offset", value: offset});
      travelExpenseFilterTemp.push({key: "limit", value: limit});
    }
    setTravelExpenseLoadHasMore(false);
    setTravelExpenseFilter([...travelExpenseFilterTemp]);
*/
  }

  const loadTravelExpenses = async () =>{
        if (!session?.accessToken) return;

        let loadTravelExpensesUrl = `${api_url}/travelExpense?`;
        /*travelExpenseFilter.map((singleFilter)=>{
          loadTravelExpensesUrl += singleFilter.key +"="+singleFilter.value+"&";
        })*/
        try{
          const fetchData = axios.get(loadTravelExpensesUrl, {
            headers: { Authorization: `Bearer ${session.accessToken}` }
          });
          const data = await fetchData;

          if(data.status != 403 && data.status != 500){

            let travelExpensesFromServer = data.data;

            /*if(travelExpenseFilter.findIndex((e)=> e.key = "offset") != -1){
              console.log("COMBINE", travelExpenseData);
              travelExpensesFromServer = travelExpensesFromServer.concat(travelExpenseData);
            }*/

            travelExpensesFromServer.sort(function(a,b){
              return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
            });
            setTravelExpenseData(travelExpensesFromServer);
            /*if(searchForText != "" || searchForStatus != "" || searchForUser != ""){
              searchFor(searchForText, searchForStatus, searchForUser);
            }*/
            setIsLoading(false);
            return data.data;
          }else{
            setIsLoading(false);
          }

        }catch (ex){
          setIsLoading(false);
        }
  }

  const loadInvoiceTypes = async () =>{
    if (!session?.accessToken) return;

    try{

      const fetchData = axios.get(`${api_url}/invoiceTypes`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;


      if(data.status != 403 && data.status != 500){
        setInoviceTypesData(data.data);

        //Next load Invoices
        ;

        return data.data;
      }
    }catch (ex){
      return
    }
  }

  const loadCreditors = async () => {
    if (!session?.accessToken) return;
    
    try {
      const fetchData = axios.get(`${api_url}/trading-partners`, { 
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){
        // Map trading partners to creditors format for backward compatibility
        setCreditorsData(data.data.tradingPartners || data.data);
        return data.data.tradingPartners || data.data; 
      }
    }catch (ex){
      return
    }
  }





  const deleteSelectedInvoices = async ()=>{
    let rekeningDataTemp = rekeningData;
    selectedInvoicesIds.map((singleInvoice)=>{
      deleteInvoice(singleInvoice._id, true);
      rekeningDataTemp = rekeningDataTemp.filter(e => e._id != singleInvoice._id);
    });
    setIsDeleteOpen(false)
    setSelectedInvoicesIds([]);
    setRekeningData(rekeningDataTemp);
  }

  const deleteInvoice = async (id, bulkDelete) =>{
    if (!session?.accessToken) return;

    const fetchData = await fetch(`${api_url}/invoices/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
      },
    })
    let rekeningDataTemp = rekeningData.filter(e => e._id != id);
    if(!bulkDelete){
      setRekeningData(rekeningDataTemp);
    }
    setEditInvoiceModified(false)
    userNotification("Delete Successfull", "Your invoice has been successfully deleted", "success");
    setChangedInvoices([])
  }

  const updateInvoice = async (data) =>{
    if (!session?.accessToken) return;
    
    let body = data

    if(data == undefined){
      return;
    }

    const fetchData = await fetch(`${api_url}/invoices/${data._id}`, {
      method: "PATCH",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    const fetchDataJson = await fetchData.json();
    if("statusCode" in fetchDataJson){
      userNotification("Update Error", fetchDataJson["message"][0], "error");
      return false;
    }else{
      userNotification("Update Successfull", "Your invoice has been successfully updated", "success");
      setChangedInvoices([fetchDataJson["_id"]]);

      await loadSingleInvoices(data._id)
      return true;
    }

  }

  const refundAll = async()=>{
    setIsLoadingRefund(true);
    await rekeningData.map(async (inv)=>{
      let tempInv = inv;
      tempInv.status = "refunded";
      await updateInvoice(tempInv);
    })
    setIsLoadingRefund(false);
    onRefundClose();
  }
  const requestRefundAll = async()=>{
    setIsLoadingRequestRefund(true);
    await rekeningData.map(async (inv)=>{
      let tempInv = inv;
      tempInv.status = "requested";
      await updateInvoice(tempInv);
    })
    setRekeningData([]);
    await loadInvoices();
    setIsLoadingRequestRefund(false);
    onRequestRefundClose();
  }

  const bulkUpdateInvoiceStatus = async()=>{
    setIsLoadingRequestRefund(true);
    let changedInvovicesIds = []
    await Promise.all(
      selectedInvoicesIds.map(async (inv) => {
        let tempInv = inv;
        tempInv.invoiceStatus = selectedInvoiceNextStep._id;
        changedInvovicesIds.push(tempInv._id);
        return updateInvoice(tempInv);
      })
    );

    setRekeningData([]);
    setSelectedInvoicesIds([]);
    setChangedInvoices(changedInvovicesIds);
    loadInvoices();
    setIsLoadingRequestRefund(false);
  }

  const toggleInvoiceSelectMonth = async (year, month)=>{
    console.log(year, month)
    let rekeningDataTemp = rekeningData;
    let forceStatus = true;
    let tempSelectedInvoiceMonths = selectedInvoiceMonths;
    console.log("tempSelectedInvoiceMonths", tempSelectedInvoiceMonths);

    if(tempSelectedInvoiceMonths.includes(year+"-"+month)){
      forceStatus = false;
      console.log("FALSE");
      let tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(item => item !== year+"-"+month);
      setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
    }else{
      tempSelectedInvoiceMonths.push(year+"-"+month);
      setSelectedInvoiceMonths(tempSelectedInvoiceMonths);
    }
    let invoicesToUpdateArray = [];
    // Step 1: Collect Promises
    rekeningDataTemp.map((item, index) => {
      const itemDate = new Date(item.date);
      const itemYear = itemDate.getFullYear();
      const itemMonth = itemDate.getMonth() + 1; // +1 to make it 1-based (January = 1)

      if (itemYear === year && itemMonth === month) {
          // Assuming toggleInvoiceSelect returns a Promise
          invoicesToUpdateArray.push({_id: item._id, status: forceStatus});
      }

    });
    toggleInvoiceSelect(invoicesToUpdateArray);
  }


  const toggleInvoiceSelect = async (invArray) => {


    let rekeningDataTemp = rekeningData,
    selectedInvoicesIdsTemp = selectedInvoicesIds;


    invArray.map((element, index)=>{

      let _id = element._id;
      let forceStatus = element.status;
      let item = rekeningDataTemp.find(el => el._id === _id);

      console.log("Selected:", item);

      const yearNew = new Date(item.date).getFullYear();
      const monthNew = new Date(item.date).getMonth() +1;
      let tempSelectedInvoiceMonths = selectedInvoiceMonths;

      if(forceStatus != undefined){
        item["selected"] = forceStatus;
        console.log("forceStatus", forceStatus);
        if(forceStatus == true){
          selectedInvoicesIdsTemp.push(item);
        }else{
          selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== _id);
          console.log("ID:", _id);
          console.log("Filtered:", selectedInvoicesIdsTemp)
        }
      }else if(item["selected"] == undefined || item["selected"] == false){
        item["selected"] = true;
        selectedInvoicesIdsTemp.push(item);
      }else{
        item["selected"] = false;
        selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== _id);

        //Deselect Month
        if(tempSelectedInvoiceMonths.includes(yearNew+"-"+monthNew)){
          forceStatus = false;
          console.log("FALSE");
          let tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(item => item !== yearNew+"-"+monthNew);
          setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
        }
      }

    })




    let invoiceType = "",
    invoiceStatus = "",
    invoiceStatusToSet = undefined,
    countDifferentInoviceTypeStatus = 0;

    selectedInvoicesIdsTemp.map((singleSelectedInvoice) =>{
      if(invoiceType == "" && invoiceStatus == ""){
        invoiceType = singleSelectedInvoice.invoiceType;
        invoiceStatus = singleSelectedInvoice.invoiceStatus;
      }
      if(invoiceType != singleSelectedInvoice.invoiceType || invoiceStatus != singleSelectedInvoice.invoiceStatus){
        countDifferentInoviceTypeStatus += 1;
      }
    });
    if(countDifferentInoviceTypeStatus == 0 && selectedInvoicesIdsTemp.length != 0){
      let invoiceTypeObject = invoiceTypesData.find(e => e._id == invoiceType);

      if(invoiceTypeObject != -1){
        let invoiceStatusObjectIndex = invoiceTypeObject.steps.findIndex(e => e._id == invoiceStatus);

        if(invoiceStatusObjectIndex < invoiceTypeObject.steps.length){
          invoiceStatusToSet = invoiceTypeObject.steps[invoiceStatusObjectIndex +1];
        }
      }

      setSelectedInvoiceNextStep(invoiceStatusToSet);
    }



    setSelectedInvoicesIds(selectedInvoicesIdsTemp);
    setRekeningData([...rekeningDataTemp]);


  }

/*
  const toggleInvoiceSelect = async (i, forceStatus = undefined) => {
    let rekeningDataTemp = rekeningData,
    selectedInvoicesIdsTemp = selectedInvoicesIds,
    item = rekeningData[i];
    const yearNew = new Date(item.date).getFullYear();
    const monthNew = new Date(item.date).getMonth() +1;
    let tempSelectedInvoiceMonths = selectedInvoiceMonths;

    if(forceStatus != undefined){
      rekeningDataTemp[i]["selected"] = forceStatus;
      console.log("forceStatus", forceStatus);
      if(forceStatus == true){
        selectedInvoicesIdsTemp.push(rekeningDataTemp[i]);
      }else{
        selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== rekeningDataTemp[i]._id);
        console.log("Filtered:", selectedInvoicesIdsTemp)
      }
    }else if(rekeningDataTemp[i]["selected"] == undefined || rekeningDataTemp[i]["selected"] == false){
      rekeningDataTemp[i]["selected"] = true;
      selectedInvoicesIdsTemp.push(rekeningDataTemp[i]);
    }else{
      rekeningDataTemp[i]["selected"] = false;
      selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== rekeningDataTemp[i]._id);

      //Deselect Month
      if(tempSelectedInvoiceMonths.includes(yearNew+"-"+monthNew)){
        forceStatus = false;
        console.log("FALSE");
        let tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(item => item !== yearNew+"-"+monthNew);
        setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
      }
    }


    let invoiceType = "",
    invoiceStatus = "",
    invoiceStatusToSet = undefined,
    countDifferentInoviceTypeStatus = 0;

    selectedInvoicesIdsTemp.map((singleSelectedInvoice) =>{
      if(invoiceType == "" && invoiceStatus == ""){
        invoiceType = singleSelectedInvoice.invoiceType;
        invoiceStatus = singleSelectedInvoice.invoiceStatus;
      }
      if(invoiceType != singleSelectedInvoice.invoiceType || invoiceStatus != singleSelectedInvoice.invoiceStatus){
        countDifferentInoviceTypeStatus += 1;
      }
    });
    if(countDifferentInoviceTypeStatus == 0 && selectedInvoicesIdsTemp.length != 0){
      let invoiceTypeObject = invoiceTypesData.find(e => e._id == invoiceType);

      if(invoiceTypeObject != -1){
        let invoiceStatusObjectIndex = invoiceTypeObject.steps.findIndex(e => e._id == invoiceStatus);

        if(invoiceStatusObjectIndex < invoiceTypeObject.steps.length){
          invoiceStatusToSet = invoiceTypeObject.steps[invoiceStatusObjectIndex +1];
        }
      }

      setSelectedInvoiceNextStep(invoiceStatusToSet);
    }




    setSelectedInvoicesIds(selectedInvoicesIdsTemp);
    setRekeningData([...rekeningDataTemp]);
  }
*/
  const previewForwards = async () =>{
    const next = rekeningData[selectedInvoice + 1];
    if (next?._id) {
      openInvoiceById(next._id);
    }
  }


  const previewBackwards = async () =>{
    const prev = rekeningData[selectedInvoice - 1];
    if (prev?._id) {
      openInvoiceById(prev._id);
    }
  }

  const openInvoice = async (id) =>{
    setEditInvoiceModified(false)

    /*router.replace({
      query: { ...router.query, i: rekeningData[id]["_id"]},
    });*/

    let currentDate = new Date().toUTCString();
    if(id == "invoice"){
      setInvoiceIdInUrl(null);
      setSelectedInvoiceId(null);
      setCreateInvoice(true);
      setCreateInvoiceType("invoice");
      setEditInvoiceReadonlyReason("");
      setEditInvoiceReadonly(false);
      /*
      let invData = emptyInvoice;
      invData.category = categoriesData[0]._id;
      saveInvoiceData(invData);
      */

      loadBudgetSpending(categoriesData[0]._id)
    }else if(id == "travel-expense"){
      console.log("Travel Expense");
      setInvoiceIdInUrl(null);
      setSelectedInvoiceId(null);
      setCreateInvoice(true);
      setCreateInvoiceType("travel-expense");
      setEditInvoiceReadonlyReason("");
      setEditInvoiceReadonly(false);
      /*
      let invData = emptyInvoice;
      invData.category = categoriesData[0]._id;
      saveInvoiceData(invData);
      */

      loadBudgetSpending(categoriesData[0]._id)
    }else{
      // Backwards compatible: if called with an index, open by ID (stable) and force a reload.
      const invoice = rekeningData?.[id];
      const invoiceId = invoice?._id;
      if (invoiceId) {
        openInvoiceById(invoiceId);
        return;
      }
    }

    invoiceOnOpen();

  }


  // Don't render main content until session is available
  // But we can't return early here because it would skip hooks below
  // Instead, we'll check session availability in the render section



  const searchForValues = async (key, value) =>{
    let searchValuesTemp = searchValues,
    searchTextIndex = searchValuesTemp.findIndex(e => e.key == key);

    if(searchTextIndex == -1){
      searchValuesTemp.push({key: key, value: value});
    }else{
      searchValuesTemp[searchTextIndex] = {key: key, value: value};
    }
    setSearchValues(searchValuesTemp);
    loadInvoices()
  }

  // New filter functions
  const updateActiveFilters = () => {
    const filters = [];
    
    if (dateFilter) {
      filters.push({
        key: "date",
        label: "Transaktionsdatum",
        value: dateFilter,
        remove: () => setDateFilter(null)
      });
    }
    
    if (receiptFilter) {
      filters.push({
        key: "receipt",
        label: "Beleg",
        value: receiptFilter,
        remove: () => setReceiptFilter(null)
      });
    }
    
    if (statusFilter) {
      // Find the readable status name
      let statusName = statusFilter;
      for (const invoiceType of invoiceTypesData) {
        const statusStep = invoiceType.steps.find(step => step._id === statusFilter);
        if (statusStep) {
          statusName = `${invoiceType.title} - ${statusStep.title}`;
          break;
        }
      }
      
      filters.push({
        key: "status",
        label: "Status",
        value: statusName,
        remove: () => setStatusFilter(null)
      });
    }
    
    if (categoryFilter) {
      // Find the readable category name
      const category = categoriesData.find(cat => cat._id === categoryFilter);
      filters.push({
        key: "category",
        label: "Kategorie",
        value: category ? category.title : categoryFilter,
        remove: () => setCategoryFilter(null)
      });
    }
    
    if (userFilter) {
      // Find the readable user name
      const user = userData.find(usr => usr._id === userFilter);
      filters.push({
        key: "user",
        label: "Benutzer",
        value: user ? user.username : userFilter,
        remove: () => setUserFilter(null)
      });
    }
    
    if (invoiceTypeFilter) {
      // Find the readable invoice type name
      const invoiceType = invoiceTypesData.find(type => type._id === invoiceTypeFilter);
      filters.push({
        key: "invoiceType",
        label: "Rechnungstyp",
        value: invoiceType ? invoiceType.title : invoiceTypeFilter,
        remove: () => setInvoiceTypeFilter(null)
      });
    }
    
    if (invoiceKindFilter) {
      // Map invoice kind to readable name
      const kindName = invoiceKindFilter === "invoice" ? "Rechnung" : 
                      invoiceKindFilter === "travel-expense" ? "Reisekosten" : 
                      invoiceKindFilter;
      filters.push({
        key: "invoiceKind",
        label: "Art",
        value: kindName,
        remove: () => setInvoiceKindFilter(null)
      });
    }
    
    if (transactionTypeFilter) {
      // Map transaction type to readable name
      const typeName = transactionTypeFilter === "incoming" ? "Eingehend" :
                      transactionTypeFilter === "outgoing" ? "Ausgehend" :
                      transactionTypeFilter === "bank_statement" ? "Kontoauszug" :
                      transactionTypeFilter === "credit_card_statement" ? "Kreditkartenabrechnung" :
                      transactionTypeFilter === "other" ? "Sonstige" :
                      transactionTypeFilter;
      filters.push({
        key: "transactionType",
        label: "Transaktionstyp",
        value: typeName,
        remove: () => setTransactionTypeFilter(null)
      });
    }
    
    if (transactionLinkedFilter) {
      filters.push({
        key: "transactionLinked",
        label: "Transaktion",
        value: transactionLinkedFilter === "linked" ? "Verknüpft" : "Nicht verknüpft",
        remove: () => setTransactionLinkedFilter(null)
      });
    }

    // Add advanced filters from searchValues
    searchValues.forEach(searchItem => {
      if (searchItem.key === "dateFilter") {
        // Map date filter values to readable names
        let dateName = searchItem.value;
        switch(searchItem.value) {
          case "thisWeek": dateName = "Diese Woche"; break;
          case "thisMonth": dateName = "Diesen Monat"; break;
          case "last3Months": dateName = "Letzte 3 Monate"; break;
          case "thisYear": dateName = "Dieses Jahr"; break;
          case "lastWeek": dateName = "Letzte Woche"; break;
          case "lastMonth": dateName = "Letzter Monat"; break;
          case "lastYear": dateName = "Vergangenes Jahr"; break;
        }
        filters.push({
          key: "advancedDate",
          label: "Transaktionsdatum",
          value: dateName,
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "dateFilter");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      } else if (searchItem.key === "amountFrom" || searchItem.key === "amountTo") {
        const existingFilter = filters.find(f => f.key === "amount");
        if (!existingFilter) {
          const fromValue = searchValues.find(s => s.key === "amountFrom")?.value || "";
          const toValue = searchValues.find(s => s.key === "amountTo")?.value || "";
          const amountText = fromValue && toValue ? `${fromValue}€ - ${toValue}€` : 
                           fromValue ? `Ab ${fromValue}€` : 
                           toValue ? `Bis ${toValue}€` : "";
          
          filters.push({
            key: "amount",
            label: "Betrag",
            value: amountText,
            remove: () => {
              const newSearchValues = searchValues.filter(item => item.key !== "amountFrom" && item.key !== "amountTo");
              setSearchValues(newSearchValues);
              loadInvoices(1);
            }
          });
        }
      } else if (searchItem.key === "searchUser" && searchItem.value !== session?.user_data?._id) {
        // Find the readable user name
        const userIds = searchItem.value.split(',');
        const userNames = userIds.map(id => {
          const user = userData.find(usr => usr._id === id);
          return user ? user.username : id;
        });
        
        filters.push({
          key: "advancedUser",
          label: "Benutzer",
          value: userNames.join(', '),
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "searchUser");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      } else if (searchItem.key === "searchCreditor") {
        // Find the readable creditor name
        const creditorIds = searchItem.value.split(',');
        const creditorNames = creditorIds.map(id => {
          const creditor = creditorsData.find(c => c._id === id);
          return creditor ? creditor.name : id;
        });
        
        filters.push({
          key: "advancedCreditor",
          label: "Karte",
          value: creditorNames.join(', '),
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "searchCreditor");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      } else if (searchItem.key === "searchCategory") {
        // Find the readable category name
        const categoryIds = searchItem.value.split(',');
        const categoryNames = categoryIds.map(id => {
          const category = categoriesData.find(c => c._id === id);
          return category ? category.title : id;
        });
        
        filters.push({
          key: "advancedCategory",
          label: "Kategorie",
          value: categoryNames.join(', '),
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "searchCategory");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      } else if (searchItem.key === "searchInvoiceType") {
        // Find the readable invoice type name
        const typeIds = searchItem.value.split(',');
        const typeNames = typeIds.map(id => {
          const type = invoiceTypesData.find(t => t._id === id);
          return type ? type.title : id;
        });
        
        filters.push({
          key: "advancedInvoiceType",
          label: "Rechnungstyp",
          value: typeNames.join(', '),
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "searchInvoiceType");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      } else if (searchItem.key === "searchInvoiceKind") {
        // Map invoice kind to readable name
        const kinds = searchItem.value.split(',');
        const kindNames = kinds.map(kind => 
          kind === "invoice" ? "Rechnung" : 
          kind === "travel-expense" ? "Reisekosten" : 
          kind
        );
        
        filters.push({
          key: "advancedInvoiceKind",
          label: "Rechnungsart",
          value: kindNames.join(', '),
          remove: () => {
            const newSearchValues = searchValues.filter(item => item.key !== "searchInvoiceKind");
            setSearchValues(newSearchValues);
            loadInvoices(1);
          }
        });
      }
    });
    
    setActiveFilters(filters);
  };

  const applyFilters = () => {
    // Only apply basic filters if no advanced filters are active
    if (searchValues.length > 0 && searchValues.some(item => 
      item.key === "dateFilter" || 
      item.key === "amountFrom" || 
      item.key === "amountTo" || 
      item.key === "transactionType" ||
      item.key === "searchCreditor"
    )) {
      // Advanced filters are active, don't override them
      return;
    }

    let searchString = "";
    
    // Add search text
    if (searchText) {
      searchString += "&searchText=" + encodeURIComponent(searchText);
    }
    
    // Add view filter
    if (filterView === "meine") {
      searchString += "&searchUser=" + (session?.user_data?._id || "");
    }
    
    // Add other filters
    if (dateFilter) {
      searchString += "&dateFilter=" + encodeURIComponent(dateFilter);
    }
    
    if (receiptFilter) {
      searchString += "&receiptFilter=" + encodeURIComponent(receiptFilter);
    }
    
    if (statusFilter) {
      searchString += "&searchInvoiceStatus=" + encodeURIComponent(statusFilter);
    }
    
    if (categoryFilter) {
      searchString += "&searchCategory=" + encodeURIComponent(categoryFilter);
    }
    
    if (userFilter) {
      searchString += "&searchUser=" + encodeURIComponent(userFilter);
    }
    
    if (invoiceTypeFilter) {
      searchString += "&searchInvoiceType=" + encodeURIComponent(invoiceTypeFilter);
    }
    
    if (invoiceKindFilter) {
      searchString += "&searchInvoiceKind=" + encodeURIComponent(invoiceKindFilter);
    }
    
    if (transactionTypeFilter) {
      searchString += "&searchTransactionType=" + encodeURIComponent(transactionTypeFilter);
    }
    
    if (transactionLinkedFilter) {
      searchString += "&transactionLinked=" + encodeURIComponent(transactionLinkedFilter);
    }
    
    // Update searchValues for compatibility
    const newSearchValues = [];
    if (searchText) newSearchValues.push({key: "searchText", value: searchText});
    if (filterView === "meine" && session?.user_data?._id) newSearchValues.push({key: "searchUser", value: session.user_data._id});
    if (statusFilter) newSearchValues.push({key: "searchInvoiceStatus", value: statusFilter});
    if (categoryFilter) newSearchValues.push({key: "searchCategory", value: categoryFilter});
    if (userFilter) newSearchValues.push({key: "searchUser", value: userFilter});
    if (invoiceTypeFilter) newSearchValues.push({key: "searchInvoiceType", value: invoiceTypeFilter});
    if (invoiceKindFilter) newSearchValues.push({key: "searchInvoiceKind", value: invoiceKindFilter});
    if (transactionTypeFilter) newSearchValues.push({key: "searchTransactionType", value: transactionTypeFilter});
    if (transactionLinkedFilter) newSearchValues.push({key: "transactionLinked", value: transactionLinkedFilter});
    
    setSearchValues(newSearchValues);
    loadInvoicesWithSearchValues(newSearchValues, 1);
  };

  // Update active filters whenever any filter changes
  React.useEffect(() => {
    updateActiveFilters();
  }, [dateFilter, receiptFilter, statusFilter, categoryFilter, userFilter, invoiceTypeFilter, invoiceKindFilter, transactionTypeFilter, transactionLinkedFilter, searchValues]);

  // Apply filters when they change
  React.useEffect(() => {
    applyFilters();
  }, [filterView, searchText, dateFilter, receiptFilter, statusFilter, categoryFilter, userFilter, invoiceTypeFilter, invoiceKindFilter, transactionTypeFilter, transactionLinkedFilter]);

  const downloadSelected = async () => {
    exportExcel(selectedInvoicesIds);
  }

  // Advanced filter functions
  const openAdvancedFilter = () => {
    onAdvancedFilterOpen();
  };

  const applyAdvancedFilters = () => {
    console.log("Applying advanced filters:", advancedFilters);
    
    // Reset basic filters
    setDateFilter(null);
    setReceiptFilter(null);
    setStatusFilter(null);
    setCategoryFilter(null);
    setUserFilter(null);
    setInvoiceTypeFilter(null);
    setInvoiceKindFilter(null);
    setTransactionLinkedFilter(null);

    // Apply advanced filters
    let newSearchValues = [];
    
    if (advancedFilters.dateRange) {
      // Handle date range filter - map to API parameters
      switch(advancedFilters.dateRange) {
        case "Diese Woche":
          newSearchValues.push({key: "dateFilter", value: "thisWeek"});
          break;
        case "Diesen Monat":
          newSearchValues.push({key: "dateFilter", value: "thisMonth"});
          break;
        case "Letzte 3 Monate":
          newSearchValues.push({key: "dateFilter", value: "last3Months"});
          break;
        case "Dieses Jahr":
          newSearchValues.push({key: "dateFilter", value: "thisYear"});
          break;
        case "Letzte Woche":
          newSearchValues.push({key: "dateFilter", value: "lastWeek"});
          break;
        case "Letzter Monat":
          newSearchValues.push({key: "dateFilter", value: "lastMonth"});
          break;
        case "Vergangenes Jahr":
          newSearchValues.push({key: "dateFilter", value: "lastYear"});
          break;
        default:
          // "Kein Datumsfilter" - no filter applied
          break;
      }
    }
    
    if (advancedFilters.amountFrom || advancedFilters.amountTo) {
      // Handle amount range filter
      if (advancedFilters.amountFrom) {
        newSearchValues.push({key: "amountFrom", value: advancedFilters.amountFrom});
      }
      if (advancedFilters.amountTo) {
        newSearchValues.push({key: "amountTo", value: advancedFilters.amountTo});
      }
    }
    
    if (advancedFilters.transactionType) {
      newSearchValues.push({key: "transactionType", value: advancedFilters.transactionType});
    }
    
    if (advancedFilters.users.length > 0) {
      // If only one user, use single ID, otherwise join with comma
      if (advancedFilters.users.length === 1) {
        newSearchValues.push({key: "searchUser", value: advancedFilters.users[0]});
      } else {
        newSearchValues.push({key: "searchUser", value: advancedFilters.users.join(',')});
      }
    }
    
    if (advancedFilters.creditors.length > 0) {
      // If only one creditor, use single ID, otherwise join with comma
      if (advancedFilters.creditors.length === 1) {
        newSearchValues.push({key: "searchCreditor", value: advancedFilters.creditors[0]});
      } else {
        newSearchValues.push({key: "searchCreditor", value: advancedFilters.creditors.join(',')});
      }
    }
    
    if (advancedFilters.categories.length > 0) {
      // If only one category, use single ID, otherwise join with comma
      if (advancedFilters.categories.length === 1) {
        newSearchValues.push({key: "searchCategory", value: advancedFilters.categories[0]});
      } else {
        newSearchValues.push({key: "searchCategory", value: advancedFilters.categories.join(',')});
      }
    }
    
    if (advancedFilters.invoiceTypes.length > 0) {
      // If only one invoice type, use single ID, otherwise join with comma
      if (advancedFilters.invoiceTypes.length === 1) {
        newSearchValues.push({key: "searchInvoiceType", value: advancedFilters.invoiceTypes[0]});
      } else {
        newSearchValues.push({key: "searchInvoiceType", value: advancedFilters.invoiceTypes.join(',')});
      }
    }
    
    if (advancedFilters.invoiceStatuses.length > 0) {
      // If only one status, use single ID, otherwise join with comma
      if (advancedFilters.invoiceStatuses.length === 1) {
        newSearchValues.push({key: "searchInvoiceStatus", value: advancedFilters.invoiceStatuses[0]});
      } else {
        newSearchValues.push({key: "searchInvoiceStatus", value: advancedFilters.invoiceStatuses.join(',')});
      }
    }
    
    if (advancedFilters.invoiceKinds.length > 0) {
      // If only one kind, use single value, otherwise join with comma
      if (advancedFilters.invoiceKinds.length === 1) {
        newSearchValues.push({key: "searchInvoiceKind", value: advancedFilters.invoiceKinds[0]});
      } else {
        newSearchValues.push({key: "searchInvoiceKind", value: advancedFilters.invoiceKinds.join(',')});
      }
    }

    console.log("New search values:", newSearchValues);

    // Update searchValues and trigger invoice loading
    setSearchValues(newSearchValues);
    onAdvancedFilterClose();
    
    // Clear current data and reload with new filters
    setRekeningData([]);
    
    // Call loadInvoices directly with the new search values to avoid timing issues
    loadInvoicesWithSearchValues(newSearchValues, 1);
  };

  // Helper function to load invoices with specific search values
  const loadInvoicesWithSearchValues = async (searchValuesToUse, pageNumber = 1) => {
    if (!session?.accessToken) return;
    
    let rekeningDataOld = rekeningData;
    if(pageNumber == 1){
      rekeningDataOld = [];
    }

    let searchString = "";

    searchValuesToUse.map((singleSearchElement)=>{
      if(singleSearchElement.value != ""){
        searchString += "&"+singleSearchElement.key+"="+encodeURIComponent(singleSearchElement.value);
      }
    })

    console.log("Loading invoices with searchValues:", searchValuesToUse);
    console.log("Search string:", searchString);
    console.log("Full URL:", `${api_url}/invoices?page=${pageNumber}&pageSize=25${searchString}`);

    setMoreInvoicesAvailable(false);
    try{
      const fetchData = axios.get(`${api_url}/invoices?page=${pageNumber}&pageSize=25${searchString}`, {
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      console.log("API response:", data.data);

      if(data.status != 403 && data.status != 500){
        let rekeningDataTempResponse = data.data;
        await rekeningDataTempResponse.map((singleInvoice, i)=>{
          if(singleInvoice.taxPositions == undefined || singleInvoice.taxPositions.length == 0){
            let tempNewTax = {value: singleInvoice.total, taxRate: singleInvoice.mwst, valueNet: singleInvoice.totalNet || "", valueTax: ""};
            rekeningDataTempResponse[i].taxPositions = [];
            rekeningDataTempResponse[i].taxPositions.push(tempNewTax);
          }
        })
        if(rekeningDataTempResponse.length == 25){
          setMoreInvoicesAvailable(true);
        }
        let invoiceDataCombined = rekeningDataTempResponse.concat(rekeningDataOld);
        setRekeningData(invoiceDataCombined);
        calculateMonthlyCost(invoiceDataCombined);
        setRekeningDataOriginal(invoiceDataCombined);
        setIsLoading(false);
        
        // Check if there are invoices in queue and show overlay if needed
        checkQueueAndShowOverlay();
        
        return invoiceDataCombined;
      }else{
        setLoginRequired(false);
        setIsLoading(false);
      }

    }catch (ex){
      console.error("Error loading invoices:", ex);
      setLoginRequired(false);
      setIsLoading(false);
    }
  };

  const clearAllFilters = () => {
    // Reset advanced filters
    setAdvancedFilters({
      dateRange: null,
      amountFrom: "",
      amountTo: "",
      transactionType: null,
      users: [],
      creditors: [],
      categories: [],
      invoiceTypes: [],
      invoiceStatuses: [],
      invoiceKinds: []
    });
    
    // Reset basic filters
    setDateFilter(null);
    setReceiptFilter(null);
    setStatusFilter(null);
    setCategoryFilter(null);
    setUserFilter(null);
    setInvoiceTypeFilter(null);
    setInvoiceKindFilter(null);
    setTransactionLinkedFilter(null);
    setSearchText("");
    
    // Clear searchValues and reload
    setSearchValues([]);
    setRekeningData([]);
    loadInvoicesWithSearchValues([], 1);
  };

  const saveAsDefault = () => {
    // TODO: Implement save as default functionality
    userNotification("Filter gespeichert", "Die Filter wurden als Standard gespeichert", "success");
  };

  // Test function to verify filters work
  const testFilter = () => {
    console.log("Testing filter...");
    const testSearchValues = [
      {key: "searchText", value: "test"},
      {key: "searchCategory", value: categoriesData[0]?._id || ""}
    ];
    console.log("Test search values:", testSearchValues);
    setSearchValues(testSearchValues);
    setRekeningData([]);
    loadInvoicesWithSearchValues(testSearchValues, 1);
  };

  const exportExcel = async(dataToExport)=>{
    const data = [];
    onDownloadOpen();
    let tempDateXls = new Date();
    let fileName = tempDateXls.getFullYear()+"-"+tempDateXls.getMonth()+"-"+tempDateXls.getDay()+"-rekening-export";
    const exportType = 'csv'
    let imageArray = [];
    dataToExport.map((item)=>{
      let newItem = {};
      newItem["Shop"] = item.shop;
      newItem["Total"] = item.total.replace(".", ",");
      newItem["TotalNet"] = item.totalNet.replace(".", ",");
      newItem["Tax"] = item.tax.replace(".", ",");
      newItem["TaxRate"] = item.mwst;
      if(item.currency != undefined){
        newItem["Currency"] = item.currency;
      }else{
        newItem["Currency"] = "EUR";
      }
      newItem["Date"] = new Date(item.date).toLocaleDateString('de-DE');
      newItem["Status"] = item.status;
      if(item.authorData.length != 0){
        newItem["Person"] = item.authorData[0].username;
      }else{
        newItem["Person"] = "Removed User";
      }
      const attachmentUrl = (item as any)?.scanAttachedSignedUrl || item.scanAttached;
      if (attachmentUrl != ""){
        let imageObject = {};
        imageObject["url"] = attachmentUrl;
        let tempDate = new Date(item.date);
        let tempDateString = tempDate.getFullYear()+"-"+(tempDate.getMonth()+1)+"-"+tempDate.getDay();
        imageObject["filename"] = tempDateString+"-"+item.shop.replace(" ", "_").toLowerCase()+"-"+item.total.replace(".",",")+"-"+item.authorData[0].username.replace(" ", "_")+"-rekening"
        imageArray.push(imageObject);

        newItem["Filename"] = imageObject["filename"];
      }
      data.push(newItem);
    });
    await handleDownload(imageArray);
    exportFromJSON({ data, fileName , exportType })
  }

  const handleDownload = (images) => {
    const zip = new JSZip();
    const imgFolder = zip.folder("images");
    const promises = [];
    let ext = "";
    images.map((image, i) =>
      promises.push(
        fetch(image["url"], (() => {
          // Signed URLs should be fetched WITHOUT Authorization header (avoids CORS preflight / blocked requests).
          // Only attach Authorization when fetching from our API or a relative URL.
          try {
            const u = new URL(image["url"]);
            if (u.hostname === "api.rekening.de") {
              return {
                method: "GET",
                headers: { Authorization: `Bearer ${session.accessToken}` },
              };
            }
            return { method: "GET" };
          } catch {
            // relative URL
            return {
              method: "GET",
              headers: { Authorization: `Bearer ${session.accessToken}` },
            };
          }
        })())
          .then(response => {
            let extArray = image["url"].split(".");
            ext = extArray.pop();
            let data = response.blob();
            return imgFolder.file(`${image["filename"]}.${ext}`, data);
          })
      )
    );
    Promise.all(promises).then(() =>
      zip.generateAsync({ type: "blob" }).then(function(content) {
        // see FileSaver.js

        let tempDateXls = new Date();
        let tempDateStringXls = tempDateXls.getFullYear()+"-"+(tempDateXls.getMonth()+1)+"-"+tempDateXls.getDay()+"-rekening-export"
        saveAs(content, tempDateStringXls+".zip");
        onDownloadClose();
        userNotification("Download Successfull","Invoices successfully downloaded","success");
      })
    );
  };


  //BULK UPLOAD CHANGE SETTINGS
  const onChangeSettingsBulkUpload = (key, val) => {

    let bulkUploadSettingsTmp = bulkUploadSettings;

    bulkUploadSettingsTmp[key] = val;
    //SAVE
    setBulkUploadSettings({...bulkUploadSettingsTmp});
  }

  const createNewInvoice = async (data, bulkUpload = false) =>{
    let body = data;


    if(data == undefined){
      return;
    }

    delete body.authorData;


    const fetchData = await fetch(`${api_url}/invoices`, {
      credentials: "include",
      method: "POST",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    const fetchDataJson = await fetchData.json();

    if("statusCode" in fetchDataJson){
      userNotification("Creation Error", fetchDataJson["message"][0], "error");

    }else{
      userNotification("New Invoice Created","Your new invoice has been successfully created","success");


      await setRekeningData([]);
      await loadInvoices()
      if(!bulkUpload  && "statusCode" in fetchDataJson == false){
        setChangedInvoices([fetchDataJson._id]);
        setTimeout(()=>{
          scroller.scrollTo(fetchDataJson._id, {
            duration: 500,
            delay: 0,
            smooth: true,
            offset: -100, // Scrolls to element + 50 pixels down the page
          })
        },200)
      }
    }
    return fetchDataJson;
  }


  //BULK UPLOAD
  type WebkitDataTransferItem = DataTransferItem & {
    webkitGetAsEntry?: () => FileSystemEntry | null;
  };

  const extractFilesFromDataTransfer = async (
    dataTransfer: DataTransfer | null
  ): Promise<File[]> => {
    if (!dataTransfer) return [];

    const fileList = Array.from(dataTransfer.files || []);
    
    // Attempt to get items for folder traversal
    const items = dataTransfer.items
      ? (Array.from(dataTransfer.items) as WebkitDataTransferItem[])
      : [];

    const entries = items
      .filter(item => item.kind === "file")
      .map(item => item.webkitGetAsEntry ? item.webkitGetAsEntry() : null)
      .filter((entry): entry is FileSystemEntry => entry !== null);

    const collectedFiles: File[] = [];

    // Helper to read file from entry safely
    const readFile = (entry: FileSystemFileEntry): Promise<File | null> => 
      new Promise(resolve => {
        try {
          entry.file(resolve, () => resolve(null));
        } catch {
          resolve(null);
        }
      });

    // Helper to read directory entries safely
    const readDir = (reader: FileSystemDirectoryReader): Promise<FileSystemEntry[]> =>
      new Promise(resolve => {
        try {
          reader.readEntries(
            (results) => resolve(Array.from(results || []) as FileSystemEntry[]),
            () => resolve([])
          );
        } catch {
          resolve([]);
        }
      });

    // Recursive traversal function
    const traverse = async (entry: FileSystemEntry) => {
      if (entry.isFile) {
        const file = await readFile(entry as FileSystemFileEntry);
        if (file) collectedFiles.push(file);
      } else if (entry.isDirectory) {
        const reader = (entry as FileSystemDirectoryEntry).createReader();
        let batch: FileSystemEntry[];
        // Read all entries in the directory (handling 100-limit pagination)
        do {
          batch = await readDir(reader);
          if (batch.length > 0) {
            await Promise.all(batch.map(traverse));
          }
        } while (batch.length > 0);
      }
    };

    // Run traversal in parallel if we have entries
    if (entries.length > 0) {
      await Promise.all(entries.map(traverse));
    }

    // Safety fallback: If traversal found nothing (or failed), use standard fileList
    // This ensures drag & drop of simple files ALWAYS works
    if (collectedFiles.length === 0 && fileList.length > 0) {
      return fileList;
    }

    // Deduplicate: merge collectedFiles with fileList (in case some were missed or traversal failed partially)
    const seen = new Set(collectedFiles.map(f => `${f.name}:${f.size}:${f.lastModified}`));
    for (const f of fileList) {
      const key = `${f.name}:${f.size}:${f.lastModified}`;
      if (!seen.has(key)) {
        collectedFiles.push(f);
        seen.add(key);
      }
    }

    return collectedFiles;
  };

  const prepareBulkUploadFromFiles = async (files) => {
    const inputFiles = Array.from(files || []).filter(Boolean);
    const expanded = await expandUploadFiles(inputFiles as File[], "invoice");
    const allowedFiles = expanded.files.filter(isAllowedInvoiceUploadFile);
    const rejectedCount =
      expanded.files.length - allowedFiles.length + expanded.skippedCount;

    if (allowedFiles.length === 0) {
      userNotification(
        t("index.uploadError") || "Upload-Fehler",
        t("index.uploadOnlyPdfImages") || "Bitte nur Ordner, ZIP-Dateien, PDFs oder Bilder hochladen.",
        "error"
      );
      return;
    }

    // If only one invoice type is available, auto-select it
    const defaultInvoiceType = invoiceTypesData.length === 1 ? invoiceTypesData[0]._id : "";
    onOpenBulkUploadPrep();
    setBulkUploadSettings({ invoiceType: defaultInvoiceType, category: "" });
    setBulkUploadCounterTotal(allowedFiles.length);
    setBulkUploadData(allowedFiles);

    if (rejectedCount > 0) {
      userNotification(
        t("index.uploadSkippedFilesTitle") || "Dateien übersprungen",
        t("index.uploadSkippedFilesDetails", { count: rejectedCount }) ||
          `${rejectedCount} Datei(en) wurden übersprungen (nur PDF/Bilder sind erlaubt; ZIPs werden sicher entpackt).`,
        "warning"
      );
    }
  };

  const bulkUploadPrep = async (ev) => {
    ev.preventDefault();
    const extracted = await extractFilesFromDataTransfer(ev.dataTransfer);
    await prepareBulkUploadFromFiles(extracted);
  }

  // Handle file input for bulk upload
  const handleFileInputChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) await prepareBulkUploadFromFiles(files);
    // Reset input value so same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }

  const handleFolderInputChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) await prepareBulkUploadFromFiles(files);
    if (folderInputRef.current) {
      folderInputRef.current.value = '';
    }
  }

  // Open file input dialog
  const openFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }

  const openFolderInput = () => {
    if (folderInputRef.current) {
      folderInputRef.current.click();
    }
  }

  const bulkUpload = async () => {
    onCloseBulkUploadPrep();
    
    // Reset counters and open upload modal
    setUploadedFileCount(0);
    setTotalFilesToUpload(bulkUploadData.length);
    setBulkUploadCounterFinished(0);
    setBulkUploadCounterTotal(bulkUploadData.length);
    setQueueEntryIds([]);
    onOpenBulkUpload();
    
    // Upload files sequentially to async endpoint
    const uploadedQueueIds = [];
    
    for (let i = 0; i < bulkUploadData.length; i++) {
      const file = bulkUploadData[i];
      
      try {
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await fetch(withInvoiceQueueConsumerTarget(`${api_url}/invoices/upload-async`), {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.accessToken}`,
          },
          body: formData,
        });
        
        const result = await response.json();
        
        if (response.ok && result._id) {
          uploadedQueueIds.push(result._id);
          setUploadedFileCount(i + 1);
          setBulkUploadCounterFinished(i + 1);
        } else {
          userNotification(
            t("index.uploadError"),
            t("index.uploadErrorDetails", { filename: file.name }),
            "error"
          );
        }
      } catch (error) {
        console.error('Upload error:', error);
        userNotification(
          t("index.uploadError"),
          t("index.uploadErrorDetails", { filename: file.name }),
          "error"
        );
      }
    }
    
    // Store queue IDs and close upload modal
    setQueueEntryIds(uploadedQueueIds);
    setInvoiceQueueCounts({ active: uploadedQueueIds.length, total: uploadedQueueIds.length });
    
    // Close upload modal after a short delay
    setTimeout(() => {
      onCloseBulkUpload();
      
      // Show queue overlay if there are uploaded files
      if (uploadedQueueIds.length > 0) {
        setIsQueueOverlayVisible(true);
      }
      
      // Reset bulk upload data
      setBulkUploadData([]);
    }, 500);
  }




  const getInvoiceQueueCounts = async () => {
    if (!session?.accessToken) return { active: 0, total: 0 };

    try {
      const response = await axios.get(`${api_url}/invoices/queue?pageSize=100&page=1`, {
        headers: { Authorization: `Bearer ${session.accessToken}` },
      });

      if (response.data) {
        // Handle both array format and object format with entries/total
        let entries = [];
        let total = 0;
        let activeCount = 0;
        
        if (Array.isArray(response.data)) {
          entries = response.data;
          total = entries.length;
        } else if (response.data.entries && Array.isArray(response.data.entries)) {
          entries = response.data.entries;
          total = response.data.total || entries.length;
        }

        if (response.data.counts) {
          total = Number(response.data.counts.total ?? total);
          activeCount = Number(response.data.counts.pending || 0) + Number(response.data.counts.processing || 0);
        } else {
          // Check if there are any pending or processing entries
          activeCount = entries.filter(
            (entry: any) => entry.status === 'pending' || entry.status === 'processing'
          ).length;
        }

        return { active: activeCount, total };
      }
    } catch (error) {
      console.error('Error checking queue:', error);
    }

    return { active: 0, total: 0 };
  };

  const checkQueueAndShowOverlay = async () => {
    const counts = await getInvoiceQueueCounts();
    setInvoiceQueueCounts(counts);

    // If there are active queue entries, show the overlay
    if (counts.active > 0 || counts.total > 0) {
      setIsQueueOverlayVisible(true);
    }
  };

  React.useEffect(() => {
    if (!session?.accessToken || invoiceQueueCounts.active <= 0) return;

    let isActive = true;
    const intervalId = setInterval(async () => {
      const counts = await getInvoiceQueueCounts();
      if (!isActive) return;
      setInvoiceQueueCounts(counts);
      if (counts.active === 0) {
        loadInvoices();
      }
    }, 2000);

    return () => {
      isActive = false;
      clearInterval(intervalId);
    };
  }, [session?.accessToken, invoiceQueueCounts.active]);

  const renderInvoiceQueueStatus = () => {
    if (invoiceQueueCounts.active <= 0) return null;

    return (
      <Box maxW="640px" mx="auto" mt={4} mb={8}>
        <Alert
          status="info"
          variant="subtle"
          borderRadius="lg"
          borderWidth="1px"
          borderColor="orange.200"
          bg="orange.50"
          alignItems="center"
        >
          <Spinner size="sm" color="orange.500" thickness="2px" mr={3} />
          <Box flex="1">
            <Text fontWeight="semibold" color="gray.800">
              {t("index.invoiceQueueStatusTitle")}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {t("index.invoiceQueueStatusDescription", { count: invoiceQueueCounts.active })}
            </Text>
          </Box>
          <Link href="/queue" passHref legacyBehavior>
            <ChakraLink fontWeight="semibold" color="orange.600" ml={4} whiteSpace="nowrap">
              {t("index.showQueue")}
            </ChakraLink>
          </Link>
        </Alert>
      </Box>
    );
  };

  const uploadDragOver = (ev) =>{
    ev.preventDefault();
  }


  const createTravelExpenseFromInvoices = async()=>{
    let newTravelExpense = emptyTravelExpense;
    newTravelExpense.childInvoices = selectedInvoicesIds;
    setTravelExpense(newTravelExpense);
    setNewTravelExpense(true);
    onTravelExpenseOpen();
  }



  if(rekeningData == null){
    return(
      <div></div>
    )
  }

  let lastDate = undefined;


  const components = {
    Card: CustomCard,
    NewCardForm: NewCardForm,
  };

  let rekeningDataBoard = {
    lanes: [
      {
        id: 'lane1',
        title: 'Planned Tasks',
        label: '2/2',
        cards: rekeningData
      },
      {
        id: 'lane2',
        title: 'Completed',
        label: '0/0',
        cards: []
      }
    ]
  }




  // Don't render main content until session is available
  // But we can't return early because it would skip hooks below (violates Rules of Hooks)
  // Instead, check session availability in the render
  if (status === "loading" || !session || !session.accessToken) {
    return (
      <Container>
        <Head>
          <title>Rekening Expense Dashboard</title>
        </Head>
        <div className='main-content'>
          {/* Loading state - useProtectedSession will handle redirect if needed */}
        </div>
      </Container>
    )
  }

  return(
    <Container onDrop={(ev)=>bulkUploadPrep(ev)} onDragOver={(ev)=>uploadDragOver(ev)}>
    <Head>
      <title>Rekening Expense Dashboard</title>
      <meta property="og:title" content="Rekening Dashboard" key="title" />
    </Head>
      <MenuElement onUpgradeOpen={onUpgradeOpen} openInvoice={openInvoice} sessionData={session} ></MenuElement>
      <div className='main-content'>
        <SubscriptionManager isUpgradeOpen={isUpgradeOpen} onUpgradeClose={onUpgradeClose} onUpgradeOpen={onUpgradeOpen} forceDisplay={false} session={session}></SubscriptionManager>
      {tabIndex == 0 &&
      <Box>
      <Box
        position="sticky"
        top={0}
        zIndex={20}
        bg="white"
        pt={2}
        pb={3}
        mb={4}
        borderBottom="1px solid"
        borderColor="gray.100"
        boxShadow="sm"
      >
      <SimpleGrid mb={"0"}>
        <GridItem>
          <Heading  as='h2' size='lg' ml="0%" mb="2" style={{width: "100%"}}>
            {t("index.allPayments")}
          </Heading>
        </GridItem>
      </SimpleGrid>

      {/* Filter Section */}
      <Box mb={0} mt={4}>
        <SimpleGrid columns={16} spacing={3}>
          {/* Search Field - Left Side */}
          <GridItem colSpan={5}>
            <InputGroup>
              <InputLeftElement>
                <IoSearch size={16} color="gray.500" />
              </InputLeftElement>
              <Input
                placeholder="Suche"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                bg="white"
                borderColor="gray.300"
                _hover={{ borderColor: "gray.400" }}
                _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px #3182ce" }}
              />
            </InputGroup>
          </GridItem>

          {/* Main Action Buttons - Right Side */}
          <GridItem colSpan={11}>
            <Box display="flex" justifyContent="flex-end" gap={3}>
              {/* Create Menu Button */}
              {(tabIndex == 0) && (session?.usage?.used < session?.usage?.limit) && (
                <Menu>
                  <MenuButton 
                    as={Button} 
                    leftIcon={<IoAddCircle />}
                    rightIcon={<IoChevronDown />} 
                    colorScheme="rekening"
                    size="md"
                    h="40px"
                    px={4}
                  >
                    {t("index.add") || "Add"}
                  </MenuButton>
                  <MenuList>
                    {/* Beleg hochladen */}
                    <MenuItem 
                      minH='45px' 
                      onClick={openFileInput}
                      icon={<IoCloudUpload size={15} />}
                    >
                      <Text as='h4' ml="2" size='sm'>
                        {t("index.uploadInvoice") || "Beleg hochladen"}
                      </Text>
                    </MenuItem>
                    <MenuItem
                      minH='45px'
                      onClick={openFolderInput}
                      icon={<IoCloudUpload size={15} />}
                    >
                      <Text as='h4' ml="2" size='sm'>
                        {t("index.uploadFolder") || "Ordner hochladen"}
                      </Text>
                    </MenuItem>
                    {/* Beleg hinzufügen */}
                    <MenuItem 
                      minH='45px' 
                      onClick={() => {openInvoice("invoice");ReactGA.event({ category: 'Invoice', action: 'Add Invoice' });}}
                      icon={<IoReceipt size={15} />}
                    >
                      <Text as='h4' ml="2" size='sm'>
                        {t("index.addInvoice") || "Beleg hinzufügen"}
                      </Text>
                    </MenuItem>
                    {/* Reisekosten hinzufügen */}
                    {session.rights?.includes("travel-expenses") && (
                      <MenuItem 
                        minH='45px' 
                        onClick={() => {openInvoice("travel-expense");ReactGA.event({ category: 'Invoice', action: 'Add Travel Expense' });}}
                        icon={<IoEarth size={15} />}
                      >
                        <Text as='h4' ml="2" size='sm'>
                          {t("index.addTravelExpense") || "Reisekosten hinzufügen"}
                        </Text>
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
              )}

              {/* Hidden file input for bulk upload */}
              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept={`application/pdf,image/*,${ZIP_UPLOAD_ACCEPT}`}
                style={{ display: 'none' }}
                onChange={handleFileInputChange}
              />
              <input
                ref={folderInputRef}
                type="file"
                multiple
                style={{ display: 'none' }}
                // webkitdirectory allows selecting whole folders (Chrome/Edge/Safari)
                {...({ webkitdirectory: "true", directory: "true" } as any)}
                onChange={handleFolderInputChange}
              />

              {/* Quick Actions Button */}
              <Menu>
                <MenuButton 
                  as={Button} 
                  rightIcon={<IoChevronDown />} 
                  variant="outline" 
                  size="md"
                  bg="white"
                  borderColor="gray.300"
                  color="gray.700"
                  _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                  h="40px"
                  px={4}
                >
                  Schnellaktionen
                </MenuButton>
                <MenuList>
                  <Text borderBottom={"1px solid #E2E8F0"} pl="3" pb="2" pt="2" fontWeight={"bold"} >{t("index.refresh")}:</Text>
                  <MenuItem minH='45px' onClick={()=>loadInvoices()}>
                    <IoRefreshCircle size={15}/>
                    <Text  as='h4' ml="2" mr="2" size='sm'>
                    {t("index.refreshData")}
                    </Text>
                  </MenuItem>
                  <Text borderBottom={"1px solid #E2E8F0"} pl="3" pb="2" pt="2" fontWeight={"bold"} >{t("download")}:</Text>
                  <MenuItem minH='45px' onClick={()=>exportExcel(rekeningData)}>
                    <IoDownload size={15}/>
                    <Text  as='h4' ml="2" mr="2" size='sm'>
                    {t("index.downloadAllVisible")}
                    </Text>
                  </MenuItem>
                  <MenuItem isDisabled={selectedInvoicesIds.length == 0} minH='45px' borderTop={"1px solid #E2E8F0"} onClick={()=>downloadSelected()}>
                    <IoCheckbox size={15} />
                    <Text  as='h4' ml="2" size='sm'>
                    {t("index.downloadSelected")}({selectedInvoicesIds.length})
                    </Text>
                  </MenuItem>
                  {selectedInvoicesIds.length != 0 &&
                  <Text borderTop={"1px solid #E2E8F0"} pl="3" pb="2" pt="2" fontWeight={"bold"}>
                    {t("index.travelExpense")}:
                  </Text>
                  }

                  {selectedInvoicesIds.length != 0 && selectedInvoicesIds.length === 0 &&
                  <MenuItem onClick={()=>createTravelExpenseFromInvoices()} minH='45px' borderTop={"1px solid #E2E8F0"}>
                    <IoGlobe size={15}/>
                    <Text  as='h4' ml="2" size='sm'>
                      {t("index.createTravelExpenseSelected")}
                    </Text>
                  </MenuItem>
                  }
                  <Text borderTop={"1px solid #E2E8F0"} pl="3" pb="2" pt="2" fontWeight={"bold"}>
                  {t("index.update")}:
                  </Text>
                  {selectedInvoiceNextStep != undefined &&
                  <MenuItem isDisabled={selectedInvoicesIds.length == 0} onClick={()=>bulkUpdateInvoiceStatus()} minH='45px' borderTop={"1px solid #E2E8F0"}>
                    <IoCheckmarkDoneCircleSharp size={15}/>
                    <Text  as='h4' ml="2" size='sm'>
                      {selectedInvoiceNextStep.title} ({selectedInvoicesIds.length})
                    </Text>
                  </MenuItem>
                  }

                  <MenuItem isDisabled={selectedInvoicesIds.length == 0} onClick={()=>setIsDeleteOpen(true)} minH='45px' borderTop={"1px solid #E2E8F0"}>
                    <IoTrash size={15}/>
                    <Text  as='h4' ml="2" size='sm'>
                    {t("index.deleteSelected")}({selectedInvoicesIds.length})
                    </Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            </Box>
          </GridItem>
        </SimpleGrid>

        {/* Filter Buttons Row - Below Action Buttons */}
        <HStack spacing={3} mt={3}>
          {/* Toggle Switch for Alle/Meine */}
          <GridItem colSpan={3}>
            <Box>
              <HStack spacing={0} bg="gray.100" p={1} borderRadius="md">
                <Button
                  size="sm"
                  variant={filterView === "alle" ? "solid" : "ghost"}
                  bg={filterView === "alle" ? "white" : "transparent"}
                  color={filterView === "alle" ? "gray.800" : "gray.600"}
                  onClick={() => setFilterView("alle")}
                  flex={1}
                  borderRadius="md"
                  boxShadow={filterView === "alle" ? "sm" : "none"}
                  _hover={{
                    bg: filterView === "alle" ? "white" : "gray.200",
                    color: filterView === "alle" ? "gray.800" : "gray.700"
                  }}
                  fontWeight="medium"
                  h="32px"
                >
                  Alle
                </Button>
                <Button
                  size="sm"
                  variant={filterView === "meine" ? "solid" : "ghost"}
                  bg={filterView === "meine" ? "white" : "transparent"}
                  color={filterView === "meine" ? "gray.800" : "gray.600"}
                  onClick={() => setFilterView("meine")}
                  flex={1}
                  borderRadius="md"
                  boxShadow={filterView === "meine" ? "sm" : "none"}
                  _hover={{
                    bg: filterView === "meine" ? "white" : "gray.200",
                    color: filterView === "meine" ? "gray.800" : "gray.700"
                  }}
                  fontWeight="medium"
                  h="32px"
                >
                  Meine
                </Button>
              </HStack>
            </Box>
          </GridItem>

          {/* Date Filter */}
          <GridItem colSpan={2}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoChevronDown />}
                variant="outline"
                size="sm"
                position="relative"
                bg="white"
                borderColor="gray.300"
                color="gray.700"
                _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                h="32px"
                px={3}
                minW="fit-content"
              >
                Transaktionsdatum
                {dateFilter && (
                  <Badge
                    colorScheme="blue"
                    position="absolute"
                    top="-1"
                    right="-1"
                    borderRadius="full"
                    fontSize="xs"
                    minW="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    1
                  </Badge>
                )}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => setDateFilter("Letzte 6 Monate")}>
                  Letzte 6 Monate
                </MenuItem>
                <MenuItem onClick={() => setDateFilter("Letzte 3 Monate")}>
                  Letzte 3 Monate
                </MenuItem>
                <MenuItem onClick={() => setDateFilter("Letzter Monat")}>
                  Letzter Monat
                </MenuItem>
                <MenuItem onClick={() => setDateFilter("Dieses Jahr")}>
                  Dieses Jahr
                </MenuItem>
              </MenuList>
            </Menu>
          </GridItem>

          {/* Receipt Filter */}
          <GridItem colSpan={2}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoChevronDown />}
                variant="outline"
                size="sm"
                position="relative"
                bg="white"
                borderColor="gray.300"
                color="gray.700"
                _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                h="32px"
                px={3}
                minW="fit-content"
              >
                Beleg
                {receiptFilter && (
                  <Badge
                    colorScheme="blue"
                    position="absolute"
                    top="-1"
                    right="-1"
                    borderRadius="full"
                    fontSize="xs"
                    minW="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    1
                  </Badge>
                )}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => setReceiptFilter("Mit Beleg")}>
                  Mit Beleg
                </MenuItem>
                <MenuItem onClick={() => setReceiptFilter("Ohne Beleg")}>
                  Ohne Beleg
                </MenuItem>
              </MenuList>
            </Menu>
          </GridItem>

          {/* Transaction Linked Filter */}
          <GridItem colSpan={2}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoChevronDown />}
                variant="outline"
                size="sm"
                position="relative"
                bg="white"
                borderColor="gray.300"
                color="gray.700"
                _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                h="32px"
                px={3}
                minW="fit-content"
              >
                Transaktion
                {transactionLinkedFilter && (
                  <Badge
                    colorScheme="blue"
                    position="absolute"
                    top="-1"
                    right="-1"
                    borderRadius="full"
                    fontSize="xs"
                    minW="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    1
                  </Badge>
                )}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => setTransactionLinkedFilter("linked")}>
                  Verknüpft
                </MenuItem>
                <MenuItem onClick={() => setTransactionLinkedFilter("unlinked")}>
                  Nicht verknüpft
                </MenuItem>
              </MenuList>
            </Menu>
          </GridItem>

          {/* Status Filter */}
          <GridItem colSpan={2}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoChevronDown />}
                variant="outline"
                size="sm"
                position="relative"
                bg="white"
                borderColor="gray.300"
                color="gray.700"
                _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                h="32px"
                px={3}
                minW="fit-content"
              >
                Status
                {statusFilter && (
                  <Badge
                    colorScheme="blue"
                    position="absolute"
                    top="-1"
                    right="-1"
                    borderRadius="full"
                    fontSize="xs"
                    minW="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    1
                  </Badge>
                )}
              </MenuButton>
              <MenuList>
                {invoiceTypesData.map((singleType) => (
                  <MenuGroup key={singleType._id} title={singleType.title}>
                    {singleType.steps.map((singleStep) => (
                      <MenuItem
                        key={singleStep._id}
                        onClick={() => setStatusFilter(singleStep._id)}
                      >
                        {singleStep.title}
                      </MenuItem>
                    ))}
                  </MenuGroup>
                ))}
              </MenuList>
            </Menu>
          </GridItem>

          {/* Transaction Type Filter */}
          <GridItem colSpan={2}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoChevronDown />}
                variant="outline"
                size="sm"
                position="relative"
                bg="white"
                borderColor="gray.300"
                color="gray.700"
                _hover={{ bg: "gray.50", borderColor: "gray.400" }}
                h="32px"
                px={3}
                minW="fit-content"
              >
                Transaktionstyp
                {transactionTypeFilter && (
                  <Badge
                    colorScheme="blue"
                    position="absolute"
                    top="-1"
                    right="-1"
                    borderRadius="full"
                    fontSize="xs"
                    minW="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    1
                  </Badge>
                )}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => setTransactionTypeFilter("incoming")}>
                  Eingehend
                </MenuItem>
                <MenuItem onClick={() => setTransactionTypeFilter("outgoing")}>
                  Ausgehend
                </MenuItem>
                <MenuItem onClick={() => setTransactionTypeFilter("bank_statement")}>
                  Kontoauszug
                </MenuItem>
                <MenuItem onClick={() => setTransactionTypeFilter("credit_card_statement")}>
                  Kreditkartenabrechnung
                </MenuItem>
                <MenuItem onClick={() => setTransactionTypeFilter("other")}>
                  Sonstige
                </MenuItem>
              </MenuList>
            </Menu>
          </GridItem>

          {/* All Filters Button */}
          <GridItem colSpan={2}>
            <Button
              leftIcon={<IoFilter size={16} />}
              variant="outline"
              size="sm"
              bg="white"
              borderColor="gray.300"
              color="gray.700"
              _hover={{ bg: "gray.50", borderColor: "gray.400" }}
              h="32px"
              px={3}
              minW="fit-content"
              onClick={openAdvancedFilter}
            >
              Alle Filter
            </Button>
          </GridItem>
        </HStack>
      </Box>

      {/* Active Filters Display */}
      {activeFilters.length > 0 && (
        <Box mb={0} mt={3}>
          <HStack spacing={2} flexWrap="wrap">
            {activeFilters.map((filter) => (
              <Badge
                key={filter.key}
                colorScheme="gray"
                borderRadius="full"
                px={3}
                py={1}
                display="flex"
                alignItems="center"
                gap={2}
                bg="gray.100"
                color="gray.700"
                border="1px solid"
                borderColor="gray.300"
              >
                <Text fontSize="xs" fontWeight="medium">
                  {filter.label}: {filter.value}
                </Text>
                <IconButton
                  size="xs"
                  variant="ghost"
                  icon={<IoClose size={12} />}
                  onClick={filter.remove}
                  aria-label={`Remove ${filter.label} filter`}
                  color="gray.500"
                  _hover={{ bg: "gray.200" }}
                />
              </Badge>
            ))}
          </HStack>
        </Box>
      )}
      </Box>

      {rekeningData.length != 0 && isLoading == false &&
        <div className='create-first-invoice'>
          <Center>
            <Heading as="h2" size={"md"} mt="10" mb="10">
              <IoCloudUpload style={{float: 'left', marginRight: "10", marginTop: "2"}}></IoCloudUpload>
              {t("index.dragAndDropHere")}
              <IoCloudUpload style={{float: 'right', marginLeft: "10", marginTop: "2"}}></IoCloudUpload>
            </Heading>
          </Center>
          {renderInvoiceQueueStatus()}
        </div>
      }
      {isLoading &&
        <Center>
          <Spinner
          thickness='5px'
          speed='1s'
          emptyColor='gray.200'
          color='orange.500'
          size='xl'
          mt="10"
          />
        </Center>
      }

    {rekeningData.length == 0 && isLoading == false &&
        <div className='create-first-invoice'>
          <Center>
            <Heading as="h2" size={"md"} mt="10">
              {t("index.needHelpForRekening")}
            </Heading>
          </Center>
          <Center>
            <Button colorScheme='rekening' mt="10" mb="10" onClick={onTutorialOpen}>
              <IoHelpCircle />
              <Text ml="1">{t("index.openUserGuide")}</Text>
            </Button>
          </Center>
        </div>
      }
      {rekeningData.length == 0 && isLoading == false &&
        <div className='create-first-invoice'>
          <Center>
            <Heading as="h2" size={"md"} mt="10">
            {t("index.dragAndDropFirstInvoice")}
            </Heading>
          </Center>
          {renderInvoiceQueueStatus()}
          <Center>
            <Heading as="h2" size={"md"} mt="10">
              {t("index.or")}
            </Heading>
          </Center>
          <Center>
            <Button colorScheme='rekening' mt="10" mb="10" onClick={openFileInput}>
              <IoAddCircle />
              <Text ml="1">{t("index.addFirstInvoice")}</Text>
            </Button>
          </Center>
        </div>
      }
      {/*rekeningData.length == 0 && isLoading == false &&
        <div className='create-first-invoice' style={{marginBottom: "120px"}}>
          <Center>
            <Heading as="h2" size={"md"} mt="10">
              {t("index.inviteTeam")}
            </Heading>
          </Center>
          <Center>
            <Button colorScheme='rekening' mt="10" mb="10" onClick={()=>{}}>
              <IoPersonAdd color="black" />
              <Text color="black" ml="1">{t("index.addUser")}</Text>
            </Button>
          </Center>
        </div>
      }*/}
      {/* KANBAN VIEW IMPLEMENT LATER rekeningData.length != 0 &&
        <Board  components={components}
        laneStyle={{
          border: "1px solid #E2E8F0",
          borderRadius: "6px",
          backgroundColor: "white"
        }}
        style={{
          backgroundColor: '#fff'
        }}  data={rekeningDataBoard} editable />
      */}

      <InfiniteScroll
        datalength={rekeningData.length}
        pageStart={0}
        loadMore={scrollLoadMoreInvoices}
        hasMore={moreInvoicesAvailable}
        loader={<Center>
          <Spinner
          thickness='5px'
          speed='1s'
          emptyColor='gray.200'
          color='orange.500'
          size='xl'
          mt="10"
          />
        </Center>}
      >
      <SimpleGrid key="invoices" style={{paddingBottom: "50px"}} columns={1} spacing={3}>
        {rekeningData.map((item, index) => {

                const date= new Date(item.date).toLocaleDateString('de-DE');

                const dateArray = [
                  t('months.January'),
                  t('months.February'),
                  t('months.March'),
                  t('months.April'),
                  t('months.May'),
                  t('months.June'),
                  t('months.July'),
                  t('months.August'),
                  t('months.September'),
                  t('months.October'),
                  t('months.November'),
                  t('months.December')
                ];

                var invDate = new Date(item.date).toLocaleString();
                //const dateArray = new Date(item.date).getMonth();
                const dateNew = new Date(item.date).getMonth();
                const yearNew = new Date(item.date).getFullYear();
                const monthNew = new Date(item.date).getMonth() +1;
                let addDateHeader = undefined,
                addDateHeaderYear = "",
                addDateHeaderCost = undefined;

                let invoiceCurrency = item.currency;
                if(invoiceCurrency == "EUR" || invoiceCurrency == "" || invoiceCurrency == undefined){
                  invoiceCurrency = "€"
                }else if(invoiceCurrency == "USD"){
                  invoiceCurrency = "$"
                }else if(invoiceCurrency == "JPY"){
                  invoiceCurrency = "¥"
                }else if(invoiceCurrency == "GBP"){
                  invoiceCurrency = "£"
                }else if(invoiceCurrency == "INR"){
                  invoiceCurrency = "₹"
                }else if(invoiceCurrency == "CAD"){
                  invoiceCurrency = "$"
                }

                if(dateNew != lastDate){
                    lastDate = dateNew;
                    addDateHeader = dateNew;
                    addDateHeaderYear = yearNew.toString();
                    addDateHeaderCost = monthlyCost[yearNew+"_"+dateNew];
                }
                if(index == rekeningData.length -1){
                    lastDate = undefined
                }

                //Mark new inovices

                let iconData = categoriesData.find((e)=> e._id == item.category)

                let IconWeb = IoBriefcase;
                if(iconData != undefined){
                  IconWeb = iconData.iconWebElement;
                }

                let invoceSelectClassList = "rekening-invoice-item";
                if(item.selected != undefined && item.selected == true){
                  invoceSelectClassList = "rekening-invoice-item selected"
                }

                if(changedInvoices.includes(item._id)){
                  invoceSelectClassList += " changed-invoice"
                }

                let invoiceStatus = "";
                let invoiceStatusColor = "cream";

                try {
                  let invoiceType = invoiceTypesData.find(e=> e._id == item.invoiceType);

                  if(invoiceType != undefined){
                    let invoiceStatusStep = invoiceType.steps.find(e=> e._id == item.invoiceStatus);
                    if(invoiceStatusStep != undefined){
                      invoiceStatus = invoiceStatusStep.title;
                      invoiceStatusColor = invoiceStatusStep.color;
                    }
                  }
                } catch (error) {

                }

                let monthSelected = "";
                if(selectedInvoiceMonths.includes(yearNew+"-"+monthNew)){
                  monthSelected = "selected"
                }

                return(
                  <div key={item._id+"list"}>
                  {addDateHeader != undefined &&

                <SimpleGrid  mb={"2"} columns={16} spacing={5}>
                    <GridItem colSpan={8}>
                      <HStack  mt="5"  spacing='7'>
                        <Box onClick={(ev)=>{toggleInvoiceSelectMonth(yearNew, monthNew)}} className={"list-checkbox "+monthSelected}>
                            <Box className='list-checkbox-inner'/>
                        </Box>
                        <Heading  as='h3' size='md' ml="0%" style={{width: "100%"}}>
                        {addDateHeaderYear} {dateArray[addDateHeader]}
                        </Heading>

                      </HStack>
                    </GridItem>
                    <GridItem colSpan={7}>
                      <Heading  as='h3' size='md' textAlign="right" ml="0%" mt="5" style={{width: "100%"}}>
                        {addDateHeaderCost}{currency}
                      </Heading>
                    </GridItem>
                  </SimpleGrid>
                  }
                  <Box className={invoceSelectClassList} padding="3" borderWidth='1px' borderRadius='lg' style={{transition: "all 0.2s"}}
                    _hover={{
                      cursor: "pointer",
                      backgroundColor: "#f4f4f4"
                    }}
                    onClick={() => {
                      openInvoiceById(item._id);
                    }}
                  >
                    <Element name={item._id}></Element>
                    <Grid templateColumns='repeat(16, 1fr)' gap={4}>
                      <GridItem colSpan={1}>
                        <HStack spacing='5px'>
                        <Box onClick={(ev)=>{
                            ev.stopPropagation();
                            ev.preventDefault();
                            toggleInvoiceSelect([{_id:item._id}])}}
                            className={"list-checkbox"}>
                              <Box className='list-checkbox-inner'/>
                        </Box>
                        {item.authorData.length != 0 && item.authorData[0].profilePicture == "" &&
                          <Avatar marginRight={2} borderRadius={10} height={45} width={45} className='rekening-invoice-avatar' name={item["authorData"][0]["username"]} />
                        }
                        {item.authorData.length != 0 && item.authorData[0].profilePicture != "" &&
                          <Avatar marginRight={2} borderRadius={10} height={45} width={45} className='rekening-invoice-avatar' src={item["authorData"][0]["profilePictureSignedUrl"] || item["authorData"][0]["profilePicture"]} />
                        }
                        {item.authorData.length == 0 &&
                          <Avatar marginRight={2} borderRadius={10} height={45} width={45} className='rekening-invoice-avatar' name={""} />
                        }
                        <div className='rekening-invoice-icon'>
                          <IconWeb style={{marginLeft: "2px", marginTop: "2px"}} fontSize={"30px"}></IconWeb>
                        </div>
                        </HStack>
                      </GridItem>
                      <GridItem colSpan={5}>
                        <Heading  as='h4' size='sm'>
                          {item.shop}
                        </Heading>
                        <Box display='flex' alignItems='baseline'>
                            {item.invoiceKind != undefined && item.invoiceKind == "travel-expense" &&
                            <IoEarth fontSize="13" style={{marginRight: 3}} color="#718096"></IoEarth>
                            }
                            <Box
                              color='gray.500'
                              fontWeight='semibold'
                              letterSpacing='wide'
                              textTransform='uppercase'
                              ml='0'
                            >
                              {date}
                            </Box>
                          </Box>
                      </GridItem>
                      <GridItem colSpan={4}>
                        {((item as any)?.scanAttachedSignedUrl || item.scanAttached) == "" && item.invoiceKind != "travel-expense" &&
                          <Heading flex="" as='h4' size='sm' color="#be3737">
                            <IoAlertCircle style={{float: "left", fontSize: 13, marginTop:"2px", marginRight: "3px"}}></IoAlertCircle>
                            {t("index.missingReceipt")}
                          </Heading>
                        }
                        {((item as any)?.scanAttachedSignedUrl || item.scanAttached) != "" && item.invoiceKind != "travel-expense" &&
                          <Heading  as='h4' size='sm'>
                            <IoReceipt style={{float: "left", fontSize: 13, marginTop:"2px", marginRight: "3px"}}></IoReceipt>
                            {t("index.receiptAttached")}
                          </Heading>
                        }
                        {item.invoiceKind == "travel-expense" &&
                          <Heading  as='h4' size='sm'>
                            <IoCar style={{float: "left", fontSize: 14, marginTop:"2px", marginRight: "3px"}}></IoCar>
                            {t("index.travelExpense")}
                          </Heading>
                        }
                        {/* Transaction Linked Status */}
                        {((item.linkedTransactionCount || 0) > 0 || item.link) && (
                          <Heading as='h4' size='sm' color="green.600" mt={1}>
                            <IoSwapHorizontal style={{float: "left", fontSize: 13, marginTop:"2px", marginRight: "3px"}}></IoSwapHorizontal>
                            {t("index.transactionLinked")}
                            {(item.linkedTransactionCount || 0) > 1 && (
                              <Badge colorScheme="green" fontSize="2xs" ml={1} verticalAlign="middle">
                                {item.linkedTransactionCount}
                              </Badge>
                            )}
                          </Heading>
                        )}
                        {(item.linkedTransactionCount || 0) === 0 && !item.link && item.invoiceKind != "travel-expense" && (
                          <Heading as='h4' size='sm' color="gray.400" mt={1}>
                            <IoSwapHorizontal style={{float: "left", fontSize: 13, marginTop:"2px", marginRight: "3px"}}></IoSwapHorizontal>
                            {t("index.transactionNotLinked")}
                          </Heading>
                        )}
                        {invoiceStatus != "" &&
                        <Box display='flex' alignItems='baseline'>
                          <Badge borderRadius='full' px='2' mt="1" pr="28px" backgroundColor={invoiceStatusColor}>
                            <IoLockClosed style={{float: "left", marginTop:"2px", marginRight: "3px"}}/>
                            <Text>{invoiceStatus}</Text>
                          </Badge>
                        </Box>
                        }
                      </GridItem>
                      <GridItem colSpan={5} textAlign="right">
                        <Heading  as='h4' size='sm'>
                          {item.total}{invoiceCurrency}
                        </Heading>
                        <Box display='flex' alignItems='baseline'>
                            {/*<Badge borderRadius='full' px='2' colorScheme='teal'>
                              Schritt {index}
                            </Badge>*/}
                            <Box
                              textAlign="right"
                              color='gray.500'
                              fontWeight='semibold'
                              letterSpacing='wide'
                              textTransform='uppercase'
                              ml='0'
                              width="100%"
                            >
                              {item.totalNet}{invoiceCurrency}
                            </Box>
                          </Box>
                      </GridItem>
                      <GridItem>
                        <div className='rekening-item-right'>
                          <IoChevronForward fontSize={"35px"}></IoChevronForward>
                        </div>
                      </GridItem>
                    </Grid>
                    </Box>

                  </div>
              )})}
            </SimpleGrid>
            </InfiniteScroll>
          </Box>
          }
      </div>

      {/*<div className="bottom-actions">
        <Flex width="95%" mt="2">
          <Spacer></Spacer>
          <Button size="md" onClick={()=>exportExcel()}>
            <IoDownload size={15}/>
            <Text  as='h4' ml="2" mr="2" size='sm'>
                Download All
            </Text>
          </Button>
        </Flex>
      </div>*/}
      <InvoiceDetailDrawer
        createInvoiceType={createInvoiceType}
        setBulkUploadCounterFinished={setBulkUploadCounterFinished}
        bulkUploadSettings={bulkUploadSettings}
        setBulkInsertData={setBulkInsertData}
        bulkInsertData={bulkInsertData}
        uploadInProgress={uploadInProgress}
        categoriesData={categoriesData}
        userData={userData}
        setUploadInProgress={setUploadInProgress}
        editInvoiceReadonly={editInvoiceReadonly}
        previewBackwards={previewBackwards}
        previewForwards={previewForwards}
        editInvoiceReadonlyReason={editInvoiceReadonlyReason}
        loadInvoices={loadInvoices}
        invoiceTypesData={invoiceTypesData}
        loadBudgetSpending={loadBudgetSpending}
        loadSingleInvoices={loadSingleInvoices}
        scroller={scroller}
        rekeningData={rekeningData}
        setRekeningData={setRekeningData}
        invoiceIsOpen={invoiceIsOpen}
        session={session}
        setChangedInvoices={setChangedInvoices}
        invoiceOnClose={closeInvoiceDrawer}
        setSelectedInvoice={setSelectedInvoice}
        selectedInvoice={selectedInvoice}
        userNotification={userNotification}
        createInvoice={createInvoice}
        setCreateInvoice={setCreateInvoice}
        setDuplicateCurrentFile={setDuplicateCurrentFile}
        setDuplicateUserDecision={setDuplicateUserDecision}
        setIsDuplicateModalOpen={setIsDuplicateModalOpen}
        />




      <Modal isOpen={isRefundOpen} onClose={onRefundClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("index.refundAll")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{t("index.sureToSet")}<b>{rekeningData.length} {t("index.pendingInvoices")}</b> {t("index.withTotalValue")} <b>{totalVisibleValue}€</b> {t("index.toRefunded")}</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onRefundClose} mr={3}>Close</Button>
            <Button isLoading={isLoadingRefund} onClick={()=>{refundAll()}} mr={3}>
              <IoCheckmarkDoneCircleSharp style={{fontSize: "1.2em", marginRight:"5px"}}></IoCheckmarkDoneCircleSharp>
              {t("index.refundDone")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isRequestRefundOpen} onClose={onRequestRefundClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("index.requestRefundAll")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{t("index.sureToRequestRefundAll")} <b>{rekeningData.length} {t("index.invoicesInProgress")}</b> {t("index.withTotalValue")} <b>{totalVisibleValue}€</b>?</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onRequestRefundClose} mr={3}>{t("close")}</Button>
            <Button isLoading={isLoadingRequestRefund} onClick={()=>{requestRefundAll()}} mr={3}>
              <IoCheckmarkDoneCircleSharp style={{fontSize: "1.2em", marginRight:"5px"}}></IoCheckmarkDoneCircleSharp>
              {t("index.requestRefundAll")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isDownloadOpen} onClose={onDownloadClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("index.downloadAllVisibleInvoices")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Center>
              <Text>{t("index.preparingDownload")}</Text>
            </Center>
            <Center mt="5">
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='orange'
                size='md'
              />
            </Center>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* BULK UPLOAD PREPERATION*/}
      <Modal closeOnOverlayClick={false} isOpen={isOpenBulkUploadPrep} onClose={onCloseBulkUploadPrep}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("index.bulkImportInvoices")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {invoiceTypesData.length > 1 && (
              <Box mt="2">
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>{t("index.invoiceType")}</Text>
                <Select
                  value={bulkUploadSettings.invoiceType}
                  onChange={(e) =>{ onChangeSettingsBulkUpload(`invoiceType`, e.target.value)}}
                >
                  <option value="" disabled>{t("index.selectInvoiceType")}</option>
                  {invoiceTypesData.map((singleCategory)=>{
                    return(
                      <option key={singleCategory._id+"-bulk-categories"} value={singleCategory._id}>{singleCategory.title}</option>
                    )
                  })}
                </Select>
              </Box>
            )}

            <Box mt="4">
              <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>{t("index.budget")} <Text as="span" color="gray.500" fontSize="xs">(Optional - AI will suggest if not selected)</Text></Text>
              <Select
                value={bulkUploadSettings.category}
                onChange={(e) =>{ onChangeSettingsBulkUpload(`category`, e.target.value)}}
              >
                <option value="">{t("index.selectCategory")} (Optional)</option>
                {categoriesData.map((singleCategory)=>{
                  return(
                    <option key={singleCategory._id+"budget"} value={singleCategory._id}>{singleCategory.title}</option>
                  )
                })}
              </Select>
            </Box>

          </ModalBody>

          <ModalFooter>
            <Button onClick={onCloseBulkUploadPrep} mr={3} variant="outline">
              {t("cancel")}
            </Button>

            <Button
              colorScheme="rekening"
              isLoading={isLoadingRefund}
              onClick={()=>{bulkUpload()}}
              disabled={invoiceTypesData.length > 1 && bulkUploadSettings.invoiceType == ""}
            >
              <IoColorWand style={{fontSize: "1.2em", marginRight:"5px"}}></IoColorWand>
              {t("index.startImport")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* BULK UPLOAD LOADER*/}
      <Modal isOpen={isOpenBulkUpload} onClose={onCloseBulkUpload}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("index.bulkImporting")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            <Center>
              {bulkUploadCounterFinished != bulkUploadCounterTotal &&
              <Spinner
                thickness='4px'
                speed={isDuplicateModalOpen? "10000s" : "0.65s"}
                emptyColor='gray.200'
                color='orange'
                size='md'
              />
              }
            </Center>
            {!isDuplicateModalOpen &&
            <Center>
              <Text mt="5">{t("index.uploadingFiles")} <b>{bulkUploadCounterFinished}</b> {t("index.outOf")} <b>{bulkUploadCounterTotal}</b> {t("index.files")}</Text>
            </Center>
            }
            <Progress mt="5" value={(bulkUploadCounterFinished/bulkUploadCounterTotal)*100} size='xs' colorScheme='orange' />

            {isDuplicateModalOpen &&
            <div>
              <Center mt="5">
                <Text><b>{t("index.duplicatedDocuments")}</b></Text>
              </Center>
              <Center mt="1">
                <Text>"{duplicateCurrentFile.name}"</Text>
              </Center>
              </div>
            }
          </ModalBody>

          <ModalFooter>
            {bulkUploadCounterFinished == bulkUploadCounterTotal &&
              <Button mr={3} onClick={onCloseBulkUpload}>
                {t("done")}
              </Button>
            }
            {bulkUploadCounterFinished != bulkUploadCounterTotal && !isDuplicateModalOpen &&
              <Button mr={3} isLoading={true} disabled={true} onClick={onCloseBulkUpload}>
                {t("done")}
              </Button>
            }
            {isDuplicateModalOpen &&
              <Button onClick={handleDuplicateOverwrite}  mr="3">
                {t("index.importDuplicate")}
              </Button>
            }
            {isDuplicateModalOpen &&
              <Button onClick={handleDuplicateSkip} colorScheme="rekening">
                {t("index.skipDocument")}
              </Button>
            }
          </ModalFooter>
        </ModalContent>
      </Modal>

      <DeleteModal
              isOpen={isDeleteOpen}
              onCancel={()=>setIsDeleteOpen(false)}
              onConfirm={deleteSelectedInvoices}
              headerMessage={t('index.deleteModal.header', { count: selectedInvoicesIds.length })}
              bodyMessage={t('deleteModal.body', { count: selectedInvoicesIds.length })}
            ></DeleteModal>

      {/* Advanced Filter Modal */}
      <Modal isOpen={isAdvancedFilterOpen} onClose={onAdvancedFilterClose} size="xl">
        <ModalOverlay />
        <ModalContent maxW="800px">
          <ModalHeader>Alle Filter</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={6} align="stretch">
              
              {/* Transaktionsdatum */}
              <Box>
                <Text fontWeight="bold" mb={3}>Transaktionsdatum</Text>
                <SimpleGrid columns={2} spacing={3}>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Diese Woche"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Diese Woche" }))}
                  >
                    Diese Woche
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Diesen Monat"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Diesen Monat" }))}
                  >
                    Diesen Monat
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Letzte 3 Monate"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Letzte 3 Monate" }))}
                  >
                    Letzte 3 Monate
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Dieses Jahr"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Dieses Jahr" }))}
                  >
                    Dieses Jahr
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Letzte Woche"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Letzte Woche" }))}
                  >
                    Letzte Woche
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Letzter Monat"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Letzter Monat" }))}
                  >
                    Letzter Monat
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Vergangenes Jahr"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Vergangenes Jahr" }))}
                  >
                    Vergangenes Jahr
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.dateRange === "Kein Datumsfilter"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, dateRange: "Kein Datumsfilter" }))}
                  >
                    Kein Datumsfilter
                  </Radio>
                </SimpleGrid>
              </Box>

              {/* Betrag */}
              <Box>
                <Text fontWeight="bold" mb={3}>Betrag</Text>
                <HStack spacing={4}>
                  <FormControl>
                    <FormLabel fontSize="sm">Von</FormLabel>
                    <Input
                      placeholder="0.00"
                      value={advancedFilters.amountFrom}
                      onChange={(e) => setAdvancedFilters(prev => ({ ...prev, amountFrom: e.target.value }))}
                      size="sm"
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel fontSize="sm">Bis</FormLabel>
                    <Input
                      placeholder="0.00"
                      value={advancedFilters.amountTo}
                      onChange={(e) => setAdvancedFilters(prev => ({ ...prev, amountTo: e.target.value }))}
                      size="sm"
                    />
                  </FormControl>
                </HStack>
              </Box>

              {/* Transaktionstyp */}
              <Box>
                <Text fontWeight="bold" mb={3}>Transaktionstyp</Text>
                <HStack spacing={6}>
                  <Radio
                    isChecked={advancedFilters.transactionType === "Haben"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, transactionType: "Haben" }))}
                  >
                    Haben
                  </Radio>
                  <Radio
                    isChecked={advancedFilters.transactionType === "Soll"}
                    onChange={() => setAdvancedFilters(prev => ({ ...prev, transactionType: "Soll" }))}
                  >
                    Soll
                  </Radio>
                </HStack>
              </Box>

              {/* Benutzer */}
              <Box>
                <Text fontWeight="bold" mb={3}>Benutzer</Text>
                <VStack align="start" spacing={2}>
                  <Checkbox
                    isChecked={advancedFilters.users.length === userData.length && userData.length > 0}
                    isIndeterminate={advancedFilters.users.length > 0 && advancedFilters.users.length < userData.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ ...prev, users: userData.map(u => u._id) }));
                      } else {
                        setAdvancedFilters(prev => ({ ...prev, users: [] }));
                      }
                    }}
                  >
                    Alle auswählen
                  </Checkbox>
                  <Checkbox
                    isChecked={session?.user_data?._id && advancedFilters.users.includes(session.user_data._id)}
                    onChange={(e) => {
                      if (e.target.checked && session?.user_data?._id) {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          users: [...prev.users, session.user_data._id] 
                        }));
                      } else {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          users: prev.users.filter(id => id !== session.user_data._id) 
                        }));
                      }
                    }}
                  >
                    Aktueller Benutzer (Ich)
                  </Checkbox>
                </VStack>
              </Box>

              {/* Karte (Creditors) */}
              <Box>
                <Text fontWeight="bold" mb={3}>Karte</Text>
                <VStack align="start" spacing={3}>
                  <InputGroup>
                    <InputLeftElement>
                      <IoSearch size={16} color="gray.500" />
                    </InputLeftElement>
                    <Input
                      placeholder={`Suche aus ${creditorsData.length} Einträgen`}
                      size="sm"
                    />
                  </InputGroup>
                  <Checkbox
                    isChecked={advancedFilters.creditors.length === creditorsData.length && creditorsData.length > 0}
                    isIndeterminate={advancedFilters.creditors.length > 0 && advancedFilters.creditors.length < creditorsData.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ ...prev, creditors: creditorsData.map(c => c._id) }));
                      } else {
                        setAdvancedFilters(prev => ({ ...prev, creditors: [] }));
                      }
                    }}
                  >
                    Alle auswählen
                  </Checkbox>
                  <SimpleGrid columns={2} spacing={2} width="100%">
                    {creditorsData.map((creditor) => (
                      <Checkbox
                        key={creditor._id}
                        isChecked={advancedFilters.creditors.includes(creditor._id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              creditors: [...prev.creditors, creditor._id] 
                            }));
                          } else {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              creditors: prev.creditors.filter(id => id !== creditor._id) 
                            }));
                          }
                        }}
                      >
                        {creditor.name} {creditor.creditorNumber}
                      </Checkbox>
                    ))}
                  </SimpleGrid>
                </VStack>
              </Box>

              {/* Kategorien */}
              <Box>
                <Text fontWeight="bold" mb={3}>Kategorien</Text>
                <VStack align="start" spacing={3}>
                  <Checkbox
                    isChecked={advancedFilters.categories.length === categoriesData.length && categoriesData.length > 0}
                    isIndeterminate={advancedFilters.categories.length > 0 && advancedFilters.categories.length < categoriesData.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ ...prev, categories: categoriesData.map(c => c._id) }));
                      } else {
                        setAdvancedFilters(prev => ({ ...prev, categories: [] }));
                      }
                    }}
                  >
                    Alle auswählen
                  </Checkbox>
                  <SimpleGrid columns={2} spacing={2} width="100%">
                    {categoriesData.map((category) => (
                      <Checkbox
                        key={category._id}
                        isChecked={advancedFilters.categories.includes(category._id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              categories: [...prev.categories, category._id] 
                            }));
                          } else {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              categories: prev.categories.filter(id => id !== category._id) 
                            }));
                          }
                        }}
                      >
                        {category.title}
                      </Checkbox>
                    ))}
                  </SimpleGrid>
                </VStack>
              </Box>

              {/* Rechnungstypen */}
              <Box>
                <Text fontWeight="bold" mb={3}>Rechnungstypen</Text>
                <VStack align="start" spacing={3}>
                  <Checkbox
                    isChecked={advancedFilters.invoiceTypes.length === invoiceTypesData.length && invoiceTypesData.length > 0}
                    isIndeterminate={advancedFilters.invoiceTypes.length > 0 && advancedFilters.invoiceTypes.length < invoiceTypesData.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ ...prev, invoiceTypes: invoiceTypesData.map(t => t._id) }));
                      } else {
                        setAdvancedFilters(prev => ({ ...prev, invoiceTypes: [] }));
                      }
                    }}
                  >
                    Alle auswählen
                  </Checkbox>
                  <SimpleGrid columns={2} spacing={2} width="100%">
                    {invoiceTypesData.map((invoiceType) => (
                      <Checkbox
                        key={invoiceType._id}
                        isChecked={advancedFilters.invoiceTypes.includes(invoiceType._id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              invoiceTypes: [...prev.invoiceTypes, invoiceType._id] 
                            }));
                          } else {
                            setAdvancedFilters(prev => ({ 
                              ...prev, 
                              invoiceTypes: prev.invoiceTypes.filter(id => id !== invoiceType._id) 
                            }));
                          }
                        }}
                      >
                        {invoiceType.title}
                      </Checkbox>
                    ))}
                  </SimpleGrid>
                </VStack>
              </Box>

              {/* Rechnungsarten */}
              <Box>
                <Text fontWeight="bold" mb={3}>Rechnungsarten</Text>
                <VStack align="start" spacing={2}>
                  <Checkbox
                    isChecked={advancedFilters.invoiceKinds.includes("invoice")}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          invoiceKinds: [...prev.invoiceKinds, "invoice"] 
                        }));
                      } else {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          invoiceKinds: prev.invoiceKinds.filter(kind => kind !== "invoice") 
                        }));
                      }
                    }}
                  >
                    Rechnung
                  </Checkbox>
                  <Checkbox
                    isChecked={advancedFilters.invoiceKinds.includes("travel-expense")}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          invoiceKinds: [...prev.invoiceKinds, "travel-expense"] 
                        }));
                      } else {
                        setAdvancedFilters(prev => ({ 
                          ...prev, 
                          invoiceKinds: prev.invoiceKinds.filter(kind => kind !== "travel-expense") 
                        }));
                      }
                    }}
                  >
                    Reisekosten
                  </Checkbox>
                </VStack>
              </Box>

            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="link" color="blue.500" onClick={clearAllFilters} mr="auto">
              Alle entfernen
            </Button>
            <Button variant="outline" colorScheme="gray" onClick={testFilter} mr={3}>
              Test Filter
            </Button>
            <Button variant="outline" colorScheme="gray" onClick={saveAsDefault} mr={3}>
              Als Standard speichern
            </Button>
            <Button colorScheme="green" onClick={applyAdvancedFilters}>
              Anwenden
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <TutorialModal isOpen={isTutorialOpen} onClose={onTutorialClose}/>
      
      {/* Queue Progress Overlay */}
      <QueueProgressOverlay
        isVisible={isQueueOverlayVisible}
        onClose={() => setIsQueueOverlayVisible(false)}
        session={session}
        onQueueEmpty={() => {
          // Refresh invoice list when queue is empty
          loadInvoices();
        }}
      />
    </Container>
  )
}
export async function getServerSideProps({req, query, locale}) {
  let headers = {}
  const tabIndexMenu = query.tabIndexMenu || 0;
  const sessionServerSide = await getSession({ req });
  let checkSubscription =  query.checkSubscription || null;
  return {
    props: {
      sessionServerSide,
      checkSubscription,
      tabIndexMenu,
      ...await serverSideTranslations(locale, [
        'common'
      ]),
    }
  }
  // Use this session information where you want.
}
export default Index